import React, { useEffect, useState, useRef } from "react"
import { useParams, withRouter } from "react-router-dom"
import { connect, useSelector } from "react-redux"
import Select from "react-select"
import {
  Row,
  Col,
  UncontrolledTooltip,
  Button,
  Card,
  CardBody,
  Table,
  Container,
  Input,
  Badge,
  Label,
  // Spinner,
} from "reactstrap"
//Import Styles
import "./styles.scss"
import PropTypes from "prop-types"
// import Multiselect from "multiselect-react-dropdown"
//import BootstrapTable from "react-bootstrap-table-next"
import api from "helpers/Api"
import { isEmpty } from "lodash"
import Modal from "react-bootstrap/Modal"
import Collapse from "react-bootstrap/Collapse"
import { style } from "pages/ClientDetails/Input-Select/select"
import { MultiSelect } from "react-multi-select-component"
import moment from "moment"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { toast } from "react-toastify"
// import SimpleReactValidator from "simple-react-validator"

//Components and store
import * as salesAction from "../../store/c2FsZXM/actions"
import * as teamSchedulingAction from "../../store/ZWNUZWFtU2NoZWR1bGl/actions"
import * as quotationAction from "../../store/cXVvdGF0/actions"
import * as freelancerAction from "../../store/c3ViZnJlZWxhbmNlcg/actions"
import SimpleReactValidator from "simple-react-validator"

const TeamSchedulingDetails = (props) => { 
  const { dispatch, clientProfile, modeMenu } = props
  const { id } = useParams()

  const companyDetails =
    !isEmpty(clientProfile) && clientProfile.leadDetails
      ? clientProfile.leadDetails[0].companyId
      : []

  const branchDetails =
    !isEmpty(clientProfile) && clientProfile.leadDetails
      ? clientProfile.leadDetails[0].branchId
      : []
  //is main event initial state

  const companyId = [companyDetails]
  const [checkboxStates, setCheckboxStates] = useState([])
  const handleCheckboxChange = (index) => {
    setCheckboxStates(prevState => ({
      ...prevState,
      [index]: !prevState[index] // Toggle the checkbox state
    }))
  }
  
 // const [isMainEvent, setIsMainEvent] = useState(false)
  //Validations
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  const branchId = [branchDetails]
  useEffect(() => {
    dispatch(teamSchedulingAction.loadTeamSchedling({ leadId: id }))
    dispatch(teamSchedulingAction.loadRecordsMetaData())
    dispatch(salesAction.loadEmployee())
    // setServiceDetailsData(eventService)
    dispatch(
      quotationAction.loadService({
        companyId,
        branchId,
        leadId: id,
        // eventId: [collapseDetails.leadEventId],
        status: "active",
      })
    )
    // dispatch(teamSchedulingAction.loadFreelancerList({status: "active"}))
    dispatch(freelancerAction.loadRecords())

    const eventScheduling = {
      status: "active",
      leadId: id,
      // eventId: leadEventId,
    }
    dispatch(teamSchedulingAction.loadEventTeamSchedling(eventScheduling))
  }, [])

  const update = useSelector((state) => state.teamScheduling)
  const salesUpdate = useSelector((specificstate) => specificstate.sales)
  const freelanceUpdate = useSelector(
    (specificstate) => specificstate.subfreelancer
  )
  const quotationUpdate = useSelector(
    (specificstate) => specificstate.quotation
  )

  const { service_details = [] } = quotationUpdate
  const { employee_list = [] } = salesUpdate
  const { records = [] } = freelanceUpdate
  const {
    team_scheduling_details = [],
    team_scheduling_services = [],
    shooter_history = [],
    recordsMetaData = {},
    agent_vacancy_details = [],
    agent_office_details = [],
    event_team_scheduling = [],
    freelancer_details = [],
  } = update

  console.log(freelancer_details, "freelancer_details")
  console.log(team_scheduling_services, "team_scheduling_services")
  const [serviceName, setServiceName] = useState("")
  console.log(serviceName, "serviceName")
  // const freelancerDetails =
  //   !isEmpty(recordsMetaData) && recordsMetaData.freelancerData
  //     ? recordsMetaData.freelancerData.data
  //     : []
  //Freelancer list options
  // const freelancerDetailsArray =
  //   !isEmpty(freelancerDetails) && freelancerDetails.length > 0
  //     ? freelancerDetails.map((e) => {
  //         if (serviceName) {
  //         // if (e.paymentDetails.map((data) => data.serviceName == serviceName)) {
  //           return {
  //             label: e.freelancerName,
  //             value: e._id,
  //             freelancerCode: e.freelancerCode,
  //             paymentDetails: e.paymentDetails,
  //             vendorMembers: e.vendorMembers,
  //             vendorType: e.vendorType,
  //           }
  //         }
  //       })
  //     : []

  // const freelancerDetailsOptions =
  //   !isEmpty(freelancerDetailsArray) && freelancerDetailsArray.length > 0
  //     ? freelancerDetailsArray.filter((data) => data != undefined)
  //     : []
  const freelancerOptionsArray =
    freelancer_details && freelancer_details && freelancer_details.length > 0
      ? freelancer_details.map((e) => {
        return {
          label: e.freelancerName,
          value: e._id,
          freelancerCode: e.freelancerCode,
          paymentDetails: e.serviceDetail,
          vendorMembers: e.vendorDetail,
          vendorType: e.vendorType,
        }
      })
      : []

  const freelancerOptions =
    !isEmpty(freelancerOptionsArray) && freelancerOptionsArray.length > 0
      ? freelancerOptionsArray.filter((data) => data != undefined)
      : []

  console.log(recordsMetaData, "recordsMetaData")
  // console.log(freelancerDetails, "freelancerDetails")
  // console.log(freelancerDetailsArray, "freelancerDetailsArray")
  console.log(freelancerOptionsArray, "freelancerOptionsArray")
  // console.log(freelancerDetailsOptions, "freelancerDetailsOptions")
  console.log(freelancerOptions, "freelancerOptions")

  // Service list dropdown
  const serviceList =
    !isEmpty(service_details) &&
    service_details.map((service) => {
      return {
        _id: service._id,
        serviceName: service.serviceName,
      }
    })

  const createServiceOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element._id
        obj.label = element.serviceName

        options.push(obj)
      })
    return options
  }

  const serviceListOptions = createServiceOptions(serviceList)

  console.log(serviceListOptions, "serviceListOptions")

  //State section
  const [tableFilterOpt, setTableFilterOpt] = useState([])
  const [historyModal, setHistoryModal] = useState(false)
  const handleHistoryModal = () => setHistoryModal(false)
  const [uploadInput, setUploadInput] = useState([])
  const [uploadTicketInput, setUploadTicketInput] = useState([])

  const [fullscreen, setFullscreen] = useState(false)
  const [open, setOpen] = useState(false)

  // const [employeeId, setEmployeeId] = useState("")

  //Final Commit
  const [eventId, setEventId] = useState("")
  const [eventCommit, setEventCommit] = useState(false)
  const [finalCommitModal, setFinalCommitModal] = useState(false)
  const [commitHistoryModal, setCommitHistoryModal] = useState(false)
  const handleCommitHistoryModal = () => setCommitHistoryModal(false)

  const [collapseDetails, setCollapseDetails] = useState("")
  const [vacancyServiceDetails, setVacancyServiceDetails] = useState("")

  //Agent vaccancy modal
  const [agentVaccancyModal, setAgentVaccancyModal] = useState(false)
  const [agentEventDate, setAgentEventDate] = useState("")
  const handleModal = () => setAgentVaccancyModal(false)

  //EVent dates
  const collapseAgentEventDate = moment(collapseDetails.eventDate).format(
    "YYYY-MM-DD"
  )
  const eventMonth = moment(collapseDetails.eventDate).format("MM")
  const eventYear = moment(collapseDetails.eventDate).format("YYYY")

  console.log(eventMonth, eventYear, "event month and year")
  console.log(vacancyServiceDetails, "vacancyServiceDetails")
  //Employee list
  const [salesAgent, setSalesAgent] = useState([])
  // const [isLoading, setIsLoading] = useState(false)
  const employeeList =
    !isEmpty(employee_list) && employee_list.length > 0
      ? employee_list.map((employee) => {
        // if (
        //   employee.departmentId === "63935d9752419c764111777a" ||
        //   employee.departmentId === "63935e3ae570e37081142963" ||
        //   employee.departmentId === "63935d9a52419c7641117bf6"
        // ) {
        return {
          _id: employee._id,
          empCode: employee.empCode,
          name: employee.name,
          companyId: employee.companyId,
          roleId: employee.roleId,
          departmentId: employee.departmentId,
          departmentName: employee.departmentName,
          designationId: employee.designationId,
          designationName: employee.designationName,
        }
        // } else if (
        //   employee.departmentId === "629481c15ff152c59fe85fa8" ||
        //   employee.departmentId === "6294823f5ff152c59fe863cf"
        // ) {
        //   return {
        //     _id: employee._id,
        //     empCode: employee.empCode,
        //     name: employee.name,
        //     companyId: employee.companyId,
        //     roleId: employee.roleId,
        //     departmentId: employee.departmentId,
        //     departmentName: employee.departmentName,
        //     designationId: employee.designationId,
        //     designationName: employee.designationName,
        //   }
        // }
      })
      : []
  const employeeListData = !isEmpty(employeeList)
    ? employeeList.filter((data) => data !== undefined)
    : []
  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.empCode = element.empCode
        obj.label = labelEmployee
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        obj.departmentId = element.departmentId
        obj.departmentName = element.departmentName
        obj.designationId = element.designationId
        obj.designationName = element.designationName
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeListData)
  console.log(employeeOptions, "employeeOptions")
  console.log(employeeListData, "employeeListData")
  console.log(employeeList, "employeeList")

  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  const currentMonth = moment().format("MMMM")
  // console.log(agent_vacancy_details, "agent_vacancy_details")
  const month = moment().format("MM")
  const year = moment().format("YYYY")
  const agentVacantMonth = moment(agentEventDate).format("MM")
  const agentVacantMonthName = moment(agentEventDate).format("MMMM")
  const agentVacantYear = moment(agentEventDate).format("YYYY")
  //Event Time

  const eventStartTimeData = moment(collapseDetails.startTime, [
    "HH.mm",
  ]).format("hh:mm a")
  const eventEndTimeData = moment(collapseDetails.endTime, ["HH.mm"]).format(
    "hh:mm a"
  )
  const crewAssemblyTimeData = !isEmpty(collapseDetails.crewAssemblyTime)
    ? moment(collapseDetails.crewAssemblyTime, ["HH.mm"]).format("hh:mm a")
    : "--"

  console.log(
    eventStartTimeData,
    eventEndTimeData,
    crewAssemblyTimeData,
    "crewAssemblyTimeData"
  )

  console.log(agentVacantMonth, agentVacantYear, "agentVacantYear")
  console.log(month, "month")
  //Agent cancay search
  const agentVacancySearch = () => {
    let record = {
      employeeId: salesAgent.value,
      departmentId: salesAgent.departmentId,
      month: !isEmpty(agentVacantMonth) ? agentVacantMonth : eventMonth,
      year: !isEmpty(agentVacantYear) ? agentVacantYear : eventMonth,
    }
    let recordSearch = {
      employeeId: salesAgent.value,
      departmentId: [salesAgent.departmentId],
      month: !isEmpty(agentVacantMonth) ? agentVacantMonth : eventMonth,
      year: !isEmpty(agentVacantYear) ? agentVacantYear : eventMonth,
    }

    console.log(record, "agent record")

    dispatch(teamSchedulingAction.loadAgentVacancy(record))
    dispatch(teamSchedulingAction.loadAgentOfficeVacancy(recordSearch))
  }

  useEffect(() => {
    if (agentVaccancyModal === true) {
      dispatch(
        teamSchedulingAction.loadAgentVacancy({
          month: eventMonth,
          year: eventYear,
        })
      )
      dispatch(
        teamSchedulingAction.loadAgentOfficeVacancy({
          month: eventMonth,
          year: eventYear,
        })
      )
    }
    setAgentEventDate(collapseAgentEventDate)
  }, [agentVaccancyModal])

  const [editModal, setEditModal] = useState(false)
  const [selectedAgentData, setSelectedAgentData] = useState("")

  console.log(selectedAgentData, "selectedAgentData")
  const agentDetails = !isEmpty(agent_vacancy_details)
    ? agent_vacancy_details.map((data) => {
      //  const scheduleDetail = data.scheduleDetail
      return data.scheduleDetail.map((data) => {
        if (data.date === data.date)
          return data.isOffice === true ? "OFFICE" : ""
      })
    })
    : []

  console.log(agentDetails, "agentDetails")

  console.log(agent_vacancy_details, "agent_vacancy_details")
  //Collapsable data
  const collapseData =
    !isEmpty(team_scheduling_details) && team_scheduling_details.length > 0
      ? team_scheduling_details
      : []
  //initial state forservice details
  const [editTeamModal, setEditTeamModal] = useState(false)
  const handleEditTeamModal = () => setEditTeamModal(false)

  const [commitHistoryDetails, setCommitHistoryDetails] = useState("")
  const [serviceDetailsData, setServiceDetailsData] = useState([
    {
      serviceNumber: "",
      serviceName: "",
      serviceNameValue: "",
      serviceFreelancerId: "",
      teamType: "",
      teamTypeId: "",
      teamTypeChoose: "",
      shooterType: "",
      shooterTypeId: "",
      shooterPosition: "",
      shooterPositionId: "",
      freelancerType: "",
      freelancerTypeId: "",
      subFreelancerType: "",
      subFreelancerTypeId: "",
      vendorMembers: "",
      freelanceAmount: "",
      subFreelanceAmount: "",
      paymentStatus: "",
      paymentStatusId: "",
      vendorType: "",
      isAlter: "",
      departmentId: "",
      uploadInput: "",
      uploadInputCount: 0,
    },
  ])

  const [renderPage, setRenderPage] = useState(false)
  // const [subFreelancerListData, setSubFreelancerListData] = useState("")
  const [removeService, setRemoveService] = useState(false)
  // const [shooterPosition, setShooterPosition] = useState("")

  const paymentStatusOptions = [
    {
      label: "Paid",
      value: "paid",
    },
    {
      label: "Free",
      value: "free",
    },
  ]
  const addServiceDetails = async () => {
    setServiceDetailsData([
      ...serviceDetailsData,
      {
        serviceNumber: "",
        serviceName: "",
        serviceNameValue: "",
        teamType: "",
        teamTypeId: "",
        shooterType: "",
        shooterTypeId: "",
        isAlter: "",
        freelancerType: "",
        freelancerTypeId: "",
        subFreelancerType: "",
        subFreelancerTypeId: "",
        vendorMembers: "",
        shooterPosition: "",
        shooterPositionId: "",
        freelanceAmount: "",
        subFreelanceAmount: "",
        vendorType: "",
        departmentId: "",
        teamTypeChoose: "InHouse",
        paymentStatus: paymentStatusOptions[1].label,
        paymentStatusId: paymentStatusOptions[1].value,
        uploadInput: "",
        index: serviceDetailsData.length,
        uploadInputCount: 0,
      },
    ])
    setRemoveService(true)
    setRenderPage(!renderPage)
    // setAddPromotions(false)
  }

  const modalChange = async (e, index, name, id) => {
    var serviceList = serviceDetailsData
    // const serviceId = collapseDetails.leadEventId
    // console.log(serviceId, "serviceId")
    if (name == "serviceNumber") {
      e = e.target.value
      serviceList[index][name] = e
      setServiceDetailsData(serviceList)
    }
    if (name == "serviceNameValue") {
      serviceList[index]["serviceNameValue"] = e.value
      serviceList[index]["serviceName"] = e.label
      setServiceDetailsData(serviceList)
    }

    if (name == "teamTypeId") {
      serviceList[index]["teamTypeId"] = e.value
      serviceList[index]["teamType"] = e.label
      serviceList[index]["shooterTypeId"] = ""
      serviceList[index]["shooterType"] = ""
      serviceList[index]["freelancerTypeId"] = ""
      serviceList[index]["freelancerType"] = ""
      serviceList[index]["subFreelancerTypeId"] = ""
      serviceList[index]["subFreelancerType"] = ""
      serviceList[index]["freelanceAmount"] = ""
      serviceList[index]["subFreelanceAmount"] = ""
      console.log(serviceList[index], "serviceList")
      console.log(e, "selected value")
      const serviceName = serviceList[index].serviceName
      console.log(serviceName, "serviceName")
      const record = {
        status: "active",
        serviceName: serviceName,
      }
      setServiceName(serviceName)
      if (e.value == "Freelancer") {
        setTimeout(() => {
          dispatch(teamSchedulingAction.loadFreelancerList(record))
        }, 1200)
      }
      setServiceDetailsData(serviceList)
    }
    if (name == "shooterTypeId") {
      serviceList[index]["shooterTypeId"] = e.value
      serviceList[index]["shooterType"] = e.label
      serviceList[index]["shooterPosition"] = e.designationName
      serviceList[index]["shooterPositionId"] = e.designationId
      serviceList[index]["departmentId"] = e.departmentId

      setServiceDetailsData(serviceList)
      console.log(e, "shooterType")
      console.log(e.designationName, "designationName")
      // setShooterPosition(e)
      // setEmployeeId(e.value)
    }
    // if(name == "shooterTypeId") {
    // }
    if (name == "freelancerTypeId") {
      serviceList[index]["freelancerTypeId"] = e.value
      serviceList[index]["freelancerType"] = e.label
      serviceList[index]["vendorMembers"] = e.vendorMembers
      serviceList[index]["subFreelancerTypeId"] = ""
      serviceList[index]["subFreelancerType"] = ""
      const freelanceAmountArray = e ? e.paymentDetails : []
      console.log(freelanceAmountArray, "freelanceAmountArray")
      const freelanceAmountData =
        !isEmpty(freelanceAmountArray) && freelanceAmountArray.length > 0
          ? freelanceAmountArray.find(
            (data) => data.serviceName == serviceList[index].serviceName
          )
          : ""

      serviceList[index]["freelanceAmount"] =
        e && !isEmpty(freelanceAmountData)
          ? freelanceAmountData.costPerSession
          : 0

      console.log(e, "e")
      console.log(freelanceAmountData, "freelanceAmountData")
      console.log(serviceList[index], "serviceList")
      serviceList[index]["vendorType"] = e.vendorType
      // setSubFreelancerListData(e.vendorMembers)
      setServiceDetailsData(serviceList)
    }
    if (name == "subFreelancerTypeId") {
      serviceList[index]["subFreelancerTypeId"] = e.value
      serviceList[index]["subFreelancerType"] = e.label

      const freelanceAmountArray = e ? e.paymentDetails : []
      console.log(freelanceAmountArray, "freelanceAmountArray")
      const freelanceAmountData =
        !isEmpty(freelanceAmountArray) && freelanceAmountArray.length > 0
          ? freelanceAmountArray.find(
            (data) => data.serviceName == serviceList[index].serviceName
          )
          : ""

      console.log(freelanceAmountData, "freelanceAmountData")
      console.log(serviceList, "serviceList")

      serviceList[index]["subFreelanceAmount"] =
        e && !isEmpty(freelanceAmountData)
          ? freelanceAmountData.costPerSession
          : 0
      // serviceList[index]["subFreelanceAmount"] =
      //   !isEmpty(e.paymentDetails) && e.paymentDetails.length > 0
      //     ? e.paymentDetails[0].costPerSession
      //     : 0
      setServiceDetailsData(serviceList)
    }
    if (name == "paymentStatusId") {
      serviceList[index]["paymentStatusId"] = e.value
      serviceList[index]["paymentStatus"] = e.label
      setServiceDetailsData(serviceList)
    }
    if (name == "freelanceAmount") {
      e = e.target.value
      serviceList[index][name] = e
      console.log(e, "freelanceAmount")
      setServiceDetailsData(serviceList)
    }
    if (name == "subFreelanceAmount") {
      e = e.target.value
      serviceList[index][name] = e
      console.log(e, "subFreelanceAmount")
      setServiceDetailsData(serviceList)
    }
    if (name == "uploadInput") {
      // e = e.target.files
      if (e.target.files) {
        console.log("qqqq", e.target.files)
        setUploadInput(e.target.files)
        serviceList[index][name] = e.target.files
        var file = e.target.files
        var fileArrayDetails = Array.from(file)
        // var teamUploadValue = serviceList

        for (let x in fileArrayDetails) {
          const formData = new FormData()
          formData.append("file", fileArrayDetails[x])
          api
            .post("/image_upload", formData)
            .then(async (res) => {
              if (res && res.data && res.data.data) {
                // teamUploadValue.push(res.data.data)
                await setServiceDetailsData(serviceList)
              } else {
                alert("Upload Failed!. Please try again")
              }
            })
            .catch(() => {
              alert("Unable to Upload file")
            })
        }
      }
      // setServiceDetailsData(serviceList)
      console.log(serviceList, "serviceList")
    }
    console.log(id, "service Id")

    setRenderPage(!renderPage)
  }

  const eventDate = moment(collapseDetails.eventDate).format("DD-MM-YYYY")
  console.log(eventDate, "eventDate")

  const uploadTicketChange = async (e) => {
    if (e.target.files) {
      console.log("qqqq", e.target.files)
      setUploadTicketInput(e.target.files)
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadTicketInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              teamUploadValue.push(res.data.data)
              await setUploadTicketInput(teamUploadValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
    }
  }
  console.log(uploadTicketInput, "UploadTicketInput")
  console.log(tableFilterOpt, "tableFilterOpt")
  // console.log(subFreelancerListData, "subFreelancerListData")

  const [finalCommitValidation, setFinalCommitValidation] = useState(false)
  const finalCommit = () => {
    var teamCommit = {
      leadId: id,
      eventId: tableFilterOpt.map((data) => data.value),
    }

    dispatch(teamSchedulingAction.teamFinalCommit(teamCommit))
    setTimeout(() => {
      dispatch(teamSchedulingAction.loadTeamSchedling({ leadId: id }))
      toast.success("Records Committed Successfully", {
        position: toast.POSITION.TOP_RIGHT,
      })
      setFinalCommitModal(false)
    }, 1500)
  }

  const eventDateDetails = collapseDetails.eventDate
    ? moment(collapseDetails.eventDate).format("YYYY-MM-DD")
    : ""

  const addTeamEvents = (e,idx) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const serviceDetails = !isEmpty(serviceDetailsData)
        ? serviceDetailsData.map((data, index) => {
          console.log(data.teamTypeId, "teamTypeId")
          console.log(data, "data")
          if (data.teamTypeId !== "InHouse") {
            return {
              serviceId: data.serviceNameValue,
              serviceNo: `${"CAM" + " 0"} ${index + 1}`,
              teamType: data.teamTypeId,
              ticket:
                data.uploadInput.length > 0 ? data.uploadInput[0].name : "",
              paymentStatus: data.paymentStatusId,
              teamFreelanceShooter: [
                {
                  freelanceMainShooterId: data.freelancerTypeId,
                  freelanceSubShooterId:
                    data.vendorType === "single"
                      ? ""
                      : data.subFreelancerTypeId,
                  amount: data.freelanceAmount,
                  isHead: !isEmpty(data.subFreelancerTypeId) ? true : false,
                  isSelected: "1",
                },
              ],
            }
          } else {
            return {
              serviceId: data.serviceNameValue,
              teamType: data.teamTypeId === "InHouse" ? "InHouse" : "",
              ticket:
                data.uploadInput.length > 0 ? data.uploadInput[0].name : "",
              paymentStatus: data.paymentStatusId,
              serviceNo: `${"CAM" + " 0"} ${index + 1}`,
              teamEmployeeShooterId: data.shooterTypeId,
              shooterPositionId: data.shooterPositionId,

            }
          }
        })
        : []
      var teamScheduling = {
        leadId: id,
        eventId: collapseDetails.leadEventId,
        isCommit: false,
        groupTicket: uploadTicketInput.map((data) => data.name),
        isNew: false,
        eventDate: eventDateDetails,
        isMainEvent: checkboxStates[idx],
        serviceDetails: serviceDetails.filter((data) => {
          return data != null
        }),
      }

      console.log(teamScheduling, "teamScheduling")
      dispatch(teamSchedulingAction.addTeamScheduling(teamScheduling))
      setTimeout(() => {
        setOpen(false)
        toast.success("Records Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        const eventScheduling = {
          status: "active",
          leadId: id,
          eventId: leadEventId,
        }
        dispatch(teamSchedulingAction.loadEventTeamSchedling(eventScheduling))
        dispatch(teamSchedulingAction.loadTeamSchedling({ leadId: id }))
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setOpen(true)
    }
  }

  //State handle
  const [leadEventId, setLeadEventId] = useState("")
  const [collapseServiceDetails, setCollapseServiceDetails] = useState("")
  const [eventServiceModal, setEventServiceModal] = useState(false)

  // const [serviceDetailDataSet, setServiceDetailDataSet] = useState(false)
  const [serviceOpen, setServiceOpen] = useState(false)
  // const [editTeamScheduleId, setEditTeamScheduleId] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)
  const [serviceDetailOpenDataSet, setServiceDetailOpenDataSet] =
    useState(false)

  const [officeDetails, setOfficeDetails] = useState("")
  const [vacancyId, setVacancyId] = useState("")
  const [vacancyIndex, setVacancyIndex] = useState("")
  const [editTeamScheduleDetails, setEditTeamScheduleDetails] = useState("")
  // const [agentServiceDetailsDataSet, setAgentServiceDetailsDataSet] =
  //   useState(false)

  //State section end
  console.log(serviceDetailsData, "serviceDetailsData")

  console.log(collapseDetails, "collapseDetails")
  // console.log(editTeamScheduleDetails, "editTeamScheduleDetails")

  //Initial collapse service details
  const collapseService =
    !isEmpty(collapseServiceDetails) && collapseServiceDetails.service
      ? collapseServiceDetails.service.map((data, index) => {
        if (collapseServiceDetails.leadEventId === leadEventId) {
          return {
            serviceNumber: "",
            teamType: "",
            teamTypeId: "",
            shooterType: "",
            shooterTypeId: "",
            freelancerType: "",
            freelancerTypeId: "",
            subFreelancerType: "",
            subFreelancerTypeId: "",
            vendorMembers: "",
            isAlter: data.isAlter,
            vendorType: "",
            paymentStatus: "PAID",
            paymentStatusId: "paid",
            freelanceAmount: "",
            _id: data._id,
            serviceName: data.serviceName,
            serviceNameValue: data.serviceId,
            uploadInput: "",
            index: index,
            uploadInputCount: 0,
          }
        }
      })
      : []
  if (
    serviceOpen &&
    collapseService &&
    collapseService.length > 0 &&
    !serviceDetailOpenDataSet
  ) {
    setServiceDetailsData(collapseService)
    setServiceDetailOpenDataSet(true)
  }

  useEffect(() => {
    if (open === true) {
      setServiceDetailsData(collapseService)
      // const historyDetails =
      //   !isEmpty(event_team_scheduling) && event_team_scheduling.length > 0
      //     ? event_team_scheduling.find(
      //         (team) => team.eventId === collapseDetails.leadEventId
      //       )
      //     : []
      // setCommitHistoryDetails(historyDetails.commitHistory)
    } else if (open === false) {
      setServiceDetailsData([])
    }
  }, [open])

  const [teamSchedulingDetails, setTeamSchedulingDetails] = useState("")

  console.log(collapseService, "collapseService")
  // console.log(editTeamScheduling, "editTeamScheduling")
  // console.log(editTeamSchedulingList, "editTeamSchedulingList")
  console.log(teamSchedulingDetails, "teamSchedulingDetails")

  //Edit Team Events
  const editTeamEvents = (event) => {
    setLeadEventId(event.leadEventId)
    const eventScheduling = {
      status: "active",
      leadId: id,
      eventId: event.leadEventId,
    }
    dispatch(teamSchedulingAction.loadEventTeamSchedling(eventScheduling))
    setEventServiceModal(true)

    console.log(event, "event edit")
  }

  const eventScheduling = {
    status: "active",
    leadId: id,
    eventId: leadEventId,
  }
  useEffect(() => {
    if (editModal === true) {
      api
        .post("get_all_event_team_schedule", eventScheduling)
        .then((res) => {
          const editTeamScheduling =
            !isEmpty(res.data.data) && res.data.data && res.data.data.length > 0
              ? res.data.data.map((data) => {
                if (data.eventId === leadEventId) {
                  return data
                }
              })
              : []
          const editTeamSchedulingList = !isEmpty(editTeamScheduling)
            ? editTeamScheduling.filter((data) => data !== undefined)
            : []

          // setServiceDetailsData(eventService)
          console.log(editTeamSchedulingList, "editTeamSchedulingList")
          // setTimeout(() => {
          setEditTeamScheduleDetails(editTeamSchedulingList)
          const ticket =
            isEmpty(editTeamSchedulingList) &&
              editTeamSchedulingList &&
              editTeamSchedulingList.length == 0
              ? 0
              : editTeamSchedulingList[0].groupTicket
          // const grouptTicket = !isEmpty(ticket) ? ticket : 0
          setTeamSchedulingDetails(editTeamSchedulingList[0])
          const historyDetails =
            !isEmpty(editTeamSchedulingList) &&
              editTeamSchedulingList.length > 0
              ? editTeamSchedulingList[0]
              : []
          console.log(historyDetails, "historyDetails")
          console.log(ticket, "ticket")

          setCommitHistoryDetails(historyDetails.commitHistory)

          const serviceDetailsSet =
            !isEmpty(editTeamSchedulingList) &&
              editTeamSchedulingList.length > 0
              ? editTeamSchedulingList[0].serviceDetails.map((data, index) => {
                const freelanceTypeId =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].freelanceMainShooterId
                    : ""
                const freelanceTypeName =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].freelanceMainShooterName
                    : ""
                const subFreelanceTypeId =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].freelanceSubShooterId
                    : ""
                const subFreelanceTypeName =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].freelanceSubShooterName
                    : ""
                // const subFreelanceTypeId = !isEmpty(data) && data.teamFreelanceShooter && data.teamFreelanceShooter.length > 0 ? data.teamFreelanceShooter[0].freelanceSubShooterId.subFreelancerName : ""
                const freelanceAmount =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].amount
                    : ""
                // const subFreelanceTypeId = !isEmpty(data) && data.teamFreelanceShooter.length > 0 ? data.teamFreelanceShooter[0].freelanceSubShooterId : []
                // const freelanceAmount = !isEmpty(data) && data.teamFreelanceShooter.length > 0 ? data.teamFreelanceShooter[0].amount : []
                console.log(freelanceTypeId, "freelanceTypeId")
                console.log(data, "data")
                return {
                  _id: data._id,
                  serviceNumber: data.serviceNo,
                  serviceName: !isEmpty(data.serviceId)
                    ? data.serviceId.serviceName
                    : "",
                  index: index,
                  serviceNameValue: !isEmpty(data.serviceId)
                    ? data.serviceId._id
                    : "",
                  teamType:
                    data.teamType === "Freelancer" ? "Freelancer" : "InHouse",
                  teamTypeId: data.teamType,
                  shooterType: !isEmpty(data.teamEmployeeShooterId)
                    ? `${data.teamEmployeeShooterId.empCode}-${data.teamEmployeeShooterId.name}`
                    : "",
                  shooterTypeId: !isEmpty(data.teamEmployeeShooterId)
                    ? data.teamEmployeeShooterId._id
                    : "",
                  shooterPositionId: !isEmpty(data.shooterPositionId)
                    ? data.shooterPositionId._id
                    : "",
                  shooterPosition: !isEmpty(data.shooterPositionId)
                    ? data.shooterPositionId.name
                    : "",
                  freelancerType: freelanceTypeName,
                  freelancerTypeId: freelanceTypeId,
                  subFreelancerType: subFreelanceTypeName,
                  subFreelancerTypeId: subFreelanceTypeId,
                  freelanceAmount: freelanceAmount,
                  isAlter: data.isAlter,
                  paymentStatus:
                    data.paymentStatus === "free" ? "FREE" : "PAID",
                  paymentStatusId:
                    data.paymentStatus === "free" ? "free" : "paid",
                  uploadInput: data.ticket,
                  vendorType:
                    !isEmpty(subFreelanceTypeId) &&
                      subFreelanceTypeId.length > 0
                      ? "multiple"
                      : "single",
                  uploadInputCount: !isEmpty(data.ticket) ? 1 : 0,
                  // vendorMembers: data.vendorMembers
                }
              })
              : []
          console.log(serviceDetailsSet, "serviceDetailsSet")
          setUploadTicketInput(ticket)
          setServiceDetailsData(serviceDetailsSet)
          // setSubFreelancerListData(subFreelanceTypeId)
          // setServiceDetailDataSet(true)
          // }, 500)
          res.data
        })
        .catch((error) => Promise.reject(error))
    }
  }, [editModal])

  // console.log(eventTeamScheduling, "eventTeamScheduling")
  console.log(leadEventId, "leadEventId")
  console.log(uploadInput, "upload Input")
  console.log(collapseDetails, "collapseDetails")
  console.log(vacancyIndex, "vacancyIndex")

  //Update team schedule events

  const updateTeamEvents = (idx) => {
    const serviceDetails = !isEmpty(serviceDetailsData)
      ? serviceDetailsData.map((data, index) => {
        console.log(data.teamTypeId, "teamTypeId")
        console.log(data, "data")
        if (data.teamType !== "InHouse") {
          return {
            _id: data._id,
            serviceId: data.serviceNameValue,
            teamType: data.teamTypeId,
            ticket: data.uploadInput,
            paymentStatus: data.paymentStatusId,
            serviceNo: `${"CAM" + " 0"} ${index + 1}`,
            // teamEmployeeShooterId: freelancerType.value,
            teamFreelanceShooter: [
              {
                freelanceMainShooterId: data.freelancerTypeId,
                freelanceSubShooterId:
                  data.vendorType === "single"
                    ? ""
                    : data.subFreelancerTypeId,

                amount: data.freelanceAmount,
                isHead: !isEmpty(data.subFreelancerTypeId) ? true : false,
                isSelected: "1",
              },
            ],
          }
        } else {
          return {
            _id: data._id,
            serviceId: data.serviceNameValue,
            teamType: data.teamType === "InHouse" ? "InHouse" : "",

            ticket: data.uploadInput,
            paymentStatus: data.paymentStatusId,
            serviceNo: `${"CAM" + " 0"} ${index + 1}`,
            teamEmployeeShooterId: data.shooterTypeId,
            shooterPositionId: data.shooterPositionId,
          }
        }
      })
      : []
    var teamScheduling = {
      _id:
        editTeamScheduleDetails && editTeamScheduleDetails.length > 0
          ? editTeamScheduleDetails[0]._id
          : "",
      leadId: id,
      eventDate: eventDateDetails,
      eventId: collapseDetails.leadEventId,
      isCommit: false,
      groupTicket:
        !isEmpty(uploadTicketInput) && uploadTicketInput.length > 0
          ? uploadTicketInput.map((data) => data.name)
          : [],
      isNew: false,
      isMainEvent: checkboxStates[idx],
      serviceDetails: serviceDetails.filter((data) => {
        return data != null
      }),
    }

    console.log(teamScheduling, "teamScheduling")
    dispatch(teamSchedulingAction.updateTeamScheduling(teamScheduling))
    setEditModal(false)
    setTimeout(() => {
      // setOpen(false)
      toast.success("Records Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
      })
      const eventScheduling = {
        status: "active",
        leadId: id,
        eventId: leadEventId,
      }
      dispatch(teamSchedulingAction.loadEventTeamSchedling(eventScheduling))
      dispatch(teamSchedulingAction.loadTeamSchedling({ leadId: id }))
    }, 1000)
  }

  const officeEditDetails = (data) => {
    setOfficeDetails(data)
    // setServiceDetailsData([
    //   {

    //   }
    // ])
    setAgentVaccancyModal(false)
  }

  const [officeSelectionDetails, setOfficeSelectionDetails] = useState("")

  //Employee Name from agent vacancy details

  const agentDetailsName =
    !isEmpty(agent_vacancy_details) && agent_vacancy_details.length > 0
      ? agent_vacancy_details.find(
        (data) => data.employeeId === officeDetails.employee_id
      )
      : []

  console.log(agentDetailsName, "agentDetailsName")
  console.log(officeSelectionDetails, "officeSelectionDetails")

  //Office selection
  useEffect(() => {
    if (agentVaccancyModal === false && !isEmpty(officeDetails)) {
      const agentServiceDetails =
        !isEmpty(vacancyServiceDetails) && vacancyServiceDetails.length > 0
          ? vacancyServiceDetails.map((data) => {
            console.log(data, "data from agent vacancy")
            console.log(data.index, "vacancy select index")
            if (data.index == vacancyIndex) {
              // const freelanceTypeId =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].freelanceMainShooterId
              //     : []
              // const freelanceTypeName =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].freelanceMainShooterName
              //     : []
              // const subFreelanceTypeId =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].freelanceSubShooterId
              //     : []
              // const subFreelanceTypeName =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].freelanceSubShooterName
              //     : []
              // const freelanceAmount =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].amount
              //     : []
              return {
                _id: data._id,
                serviceNumber: data.serviceNumber,
                serviceName: !isEmpty(data.serviceName)
                  ? data.serviceName
                  : "",
                serviceNameValue: !isEmpty(data.serviceNameValue)
                  ? data.serviceNameValue
                  : "",
                teamType: data.teamType,
                teamTypeId: data.teamType,
                shooterType: !isEmpty(agentDetailsName)
                  ? agentDetailsName.employeeName
                  : "",
                departmentId: data.departmentId,
                shooterTypeId: !isEmpty(officeDetails)
                  ? officeDetails.employee_id
                  : "",
                shooterPositionId: !isEmpty(agentDetailsName)
                  ? agentDetailsName.designationId
                  : "",
                shooterPosition: !isEmpty(agentDetailsName)
                  ? agentDetailsName.designationName
                  : "",
                index: data.index,
                subFreelancerType: data.subFreelanceType,
                subFreelancerTypeId: data.subFreelanceTypeId,
                freelancerType: data.freelanceType,
                freelancerTypeId: data.freelanceTypeId,
                freelanceAmount: data.freelanceAmount,
                paymentStatus:
                  data.paymentStatus === "free" || removeService
                    ? "FREE"
                    : "PAID",
                paymentStatusId: data.paymentStatus,
                uploadInput: data.uploadInput,
                uploadInputCount: data.uploadInputCount,
              }
            }
          })
          : []

      //VacancyId not Equal selection
      const agentVacancyDetails =
        !isEmpty(vacancyServiceDetails) && vacancyServiceDetails.length > 0
          ? vacancyServiceDetails.map((data) => {
            console.log(data.length, "vacancy length")

            if (data.index != vacancyIndex) {
              // const freelanceTypeId =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].freelanceMainShooterId
              //     : []
              // const freelanceTypeName =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].freelanceMainShooterName
              //     : []
              // const subFreelanceTypeId =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].freelanceSubShooterId
              //     : []
              // const subFreelanceTypeName =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].freelanceSubShooterName
              //     : []
              // const freelanceAmount =
              //   !isEmpty(data) &&
              //   data.teamFreelanceShooter &&
              //   data.teamFreelanceShooter.length > 0
              //     ? data.teamFreelanceShooter[0].amount
              //     : []
              return {
                _id: data._id,
                serviceNumber: data.serviceNumber,
                serviceName: !isEmpty(data.serviceName)
                  ? data.serviceName
                  : "",
                index: data.index,
                serviceNameValue: !isEmpty(data.serviceNameValue)
                  ? data.serviceNameValue
                  : "",
                teamType: data.teamType,
                teamTypeId: data.teamType,
                shooterType: !isEmpty(data.shooterType)
                  ? data.shooterType
                  : "",
                shooterTypeId: !isEmpty(data.shooterTypeId)
                  ? data.shooterTypeId
                  : "",
                shooterPositionId: !isEmpty(data.shooterPositionId)
                  ? data.shooterPositionId
                  : "",
                shooterPosition: !isEmpty(data.shooterPosition)
                  ? data.shooterPosition
                  : "",
                subFreelancerType: data.subFreelanceType,
                subFreelancerTypeId: data.subFreelanceTypeId,
                freelancerType: data.freelanceType,
                freelancerTypeId: data.freelanceTypeId,
                freelanceAmount: data.freelanceAmount,
                paymentStatus:
                  data.paymentStatus === "free" ? "FREE" : "PAID",
                paymentStatusId: data.paymentStatus,
                uploadInput: data.uploadInput,
                uploadInputCount: data.uploadInputCount,
              }
            }
          })
          : []

      const agentVacancyServiceDetails =
        !isEmpty(agentVacancyDetails) && agentVacancyDetails.length > 0
          ? agentVacancyDetails.filter((data) => data !== undefined)
          : []
      const agentServiceVacancyDetails =
        !isEmpty(agentServiceDetails) && agentServiceDetails.length > 0
          ? agentServiceDetails.filter((data) => data !== undefined)
          : []

      //Two arrays concatination
      const officeSelectionServiceDetails =
        agentServiceVacancyDetails &&
          agentServiceVacancyDetails.length > 0 &&
          agentVacancyServiceDetails &&
          agentVacancyServiceDetails.length > 0
          ? agentServiceVacancyDetails.concat(agentVacancyServiceDetails)
          : !isEmpty(agentServiceVacancyDetails) &&
            isEmpty(agentVacancyServiceDetails)
            ? agentServiceVacancyDetails
            : isEmpty(agentServiceVacancyDetails) &&
              !isEmpty(agentVacancyServiceDetails)
              ? agentVacancyServiceDetails
              : []

      const sortAndMap = (arr = []) => {
        const copy = arr.slice()
        const sorter = (a, b) => {
          return a["index"] - b["index"]
        }
        copy.sort(sorter)

        return copy
      }
      const officeDetailsSelected = sortAndMap(officeSelectionServiceDetails)
      console.log(officeDetailsSelected, "officeDetailsSelected")
      setServiceDetailsData(officeDetailsSelected)
      // setTimeout(() => {

      // }, 1000)
      console.log(agentVacancyServiceDetails, "agentVacancyServiceDetails")
      console.log(
        officeSelectionServiceDetails,
        "officeSelectionServiceDetails"
      )
      console.log(serviceDetailsData, "serviceDetailsData")
      console.log(agentServiceVacancyDetails, "agentServiceVacancyDetails")
    } else if (isEmpty(officeDetails)) {
      // setVacancyIndex("")
      setServiceDetailsData(serviceDetailsData)
    } else if (removeService === true && agentVaccancyModal === false) {
      setServiceDetailsData(serviceDetailsData)
    }
  }, [agentVaccancyModal])

  console.log(officeDetails, "officeDetails")
  console.log(vacancyId, "vacancyId")
  const teamOptions = [
    {
      label: "InHouse",
      value: "InHouse",
    },
    {
      label: "Freelancer",
      value: "Freelancer",
    },
  ]

  // const serviceTeamOptions = [
  //   {
  //     label: "InHouse",
  //     value: "InHouse",
  //   },
  // ]

  //Commit History Details
  const [eventCommitHistory, setEventCommitHistory] = useState(false)
  useEffect(() => {
    if (eventCommitHistory === true) {
      setTimeout(() => {
        const eventCommitDetails =
          !isEmpty(event_team_scheduling) && event_team_scheduling.length > 0
            ? event_team_scheduling.filter((team) => team.eventId === eventId)
            : 0

        const eventCommitData = !isEmpty(eventCommitDetails)
          ? eventCommitDetails[0]
          : 0
        console.log(eventCommitDetails, "eventCommitDetails")
        console.log(eventCommitData, "eventCommitData")
        setTeamSchedulingDetails(eventCommitData)

        const eventScheduling = {
          status: "active",
          leadId: id,
          eventId: leadEventId,
        }
        dispatch(teamSchedulingAction.loadEventTeamSchedling(eventScheduling))
        api
          // .post("get_all_equipment_type", { status: "active" })
          .post("get_all_event_team_schedule", eventScheduling)
          .then((res) => {
            console.log(res.data, "response data")
            const commitHistoryDetails =
              !isEmpty(res.data) &&
                res.data &&
                res.data.data &&
                res.data.data.length > 0
                ? res.data.data[0].commitHistory
                : []
            setCommitHistoryDetails(commitHistoryDetails)
            res.data
          })
        setTimeout(() => {
          setEventCommitHistory(false)
        }, 1000)
      }, 2000)
    }
  }, [eventCommitHistory])

  console.log(commitHistoryDetails, "commitHistoryDetails")

  const commitOptions = !isEmpty(collapseData)
    ? collapseData.map((data) => {
      if (data.isUpdate === true) {
        return {
          label: data.eventNo,
          value: data.leadEventId,
        }
      }
    })
    : []
  const finalCommitOptions = !isEmpty(commitOptions)
    ? commitOptions.filter((data) => data !== undefined)
    : []
  const handleEventCommitModal = () => setEventCommit(false)
  const handleFinalCommitModal = () => setFinalCommitModal(false)

  //Event final commit
  const eventFinalCommit = () => {
    var teamCommit = {
      leadId: id,
      eventId: [eventId],
    }
    // const eventScheduling = {
    //   status: "active",
    //   leadId: id,
    //   eventId: leadEventId,
    // }

    dispatch(teamSchedulingAction.teamFinalCommit(teamCommit))
    setEventCommitHistory(true)
    setTimeout(() => {
      dispatch(teamSchedulingAction.loadTeamSchedling({ leadId: id }))
      // dispatch(teamSchedulingAction.loadEventTeamSchedling(eventScheduling))

      toast.success("Records Committed Successfully", {
        position: toast.POSITION.TOP_RIGHT,
      })
      setEventCommit(false)
    }, 1500)
  }

  const removeServiceDetails = async (toRemove) => {
    var serviceDetail = serviceDetailsData
    if (toRemove != 0) {
      if (toRemove > -1) {
        serviceDetail.splice(toRemove, 1)
      }
      setServiceDetailsData(serviceDetail)
      // setRemoveService(false)
      setRenderPage(!renderPage)
    }
  }
  // const removeSubFreelancerDetails = async (toRemove) => {
  //   var subFreelancerTypeId = serviceDetailsData.map(
  //     (data) => data.subFreelancerTypeId
  //   )
  //   var subFreelanceAmount = serviceDetailsData.map(
  //     (data) => data.subFreelanceAmount
  //   )
  //   const freelanceArray = subFreelancerTypeId.concat(subFreelanceAmount)
  //   if (toRemove != 0) {
  //     if (toRemove > -1) {
  //       subFreelancerTypeId.splice(toRemove, 1)
  //       subFreelanceAmount.splice(toRemove, 1)
  //     }
  //     setServiceDetailsData(freelanceArray)
  //     // setRemoveService(false)
  //     setRenderPage(!renderPage)
  //   }
  // }

  const [teamServiceEventId, setTeamServiceEventId] = useState("")
  const [removeTeamServiceEvent, setRemoveTeamServiceEvent] = useState(false)
  const handleRemoveServiceEvent = () => setRemoveTeamServiceEvent(false)
  const [teamScheduleServiceDetails, setTeamScheduleServiceDetails] = useState(
    {
      addLeadService: [],
      removeLeadService: [],
      serviceQuantityRemove: [],
      serviceQuantityUpdate: [],
    }
    //   {
    //     serviceName: "",
    //     serviceId: "",
    //     serviceNo: "",
    //     type: "",
    //     shooterName: "",
    //   },
    // ""
  )
  const record = {
    leadId: id,
    eventId: teamServiceEventId,
  }

  const [removeServiceDetailsObjId, setRemoveServiceDetailsObjId] = useState("")

  console.log(removeServiceDetailsObjId, "removeServiceDetailsObjId")
  useEffect(() => {
    if (editTeamModal == true) {
      // dispatch(teamSchedulingAction.loadTeamSchedlingService(record))
      api
        .post("get_event_team_schedule_detils_from_lead", record)
        .then((res) => {
          console.log(res.data, "response")
          setTeamScheduleServiceDetails({
            addLeadService: !isEmpty(res.data.data.addLeadService)
              ? res.data.data.addLeadService
              : [],
            removeLeadService: !isEmpty(res.data.data.removeLeadService)
              ? res.data.data.removeLeadService
              : [],
            serviceQuantityUpdate: !isEmpty(res.data.data.serviceQuantityUpdate)
              ? res.data.data.serviceQuantityUpdate
              : [],
            serviceQuantityRemove: !isEmpty(res.data.data.serviceQuantityRemove)
              ? res.data.data.serviceQuantityRemove
              : [],
          })
          const quantityRemove = !isEmpty(res.data.data.serviceQuantityRemove)
            ? res.data.data.serviceQuantityRemove.find(
              (data) => data.updateKey == "removed"
            )
            : ""

          const quantityRemoveArray = !isEmpty(quantityRemove)
            ? quantityRemove._id
            : ""
          setRemoveServiceDetailsObjId(quantityRemoveArray)

          res.data
        })
        .catch((error) => Promise.reject(error))
      // console.log(serviceTable, "serviceTable")
    }
  }, [editTeamModal])

  const [removeServiceName, setRemoveServiceName] = useState("")
  const [removeServiceNameId, setRemoveServiceNameId] = useState("")
  const [removeServiceArrayDataId, setRemoveServiceArrayDataId] = useState([])
  const [removeServiceListName, setRemoveServiceListName] = useState([])
  const [undoServiceListName, setUndoServiceListName] = useState("")
  const [updateServiceConfirmation, setUpdateServiceConfirmation] = useState("")
  const handleRemoveServiceConfirmation = () =>
    setUpdateServiceConfirmation(false)
  const [undoServiceConfirmation, setUndoServiceConfirmation] = useState("")
  const [serviceGroup, setServiceGroup] = useState([])
  const handleUndoServiceConfirmation = () => setUndoServiceConfirmation(false)

  console.log(
    serviceGroup,
    setServiceGroup,
    setRemoveServiceArrayDataId,
    setRemoveServiceListName,
    "serviceGroup"
  )
  console.log(removeServiceArrayDataId, "removeServiceArrayDataId")
  console.log(undoServiceListName, "undoServiceListName")
  const serviceGroupRemovalCount = !isEmpty(teamScheduleServiceDetails) && teamScheduleServiceDetails.serviceQuantityRemove.length > 0 ? teamScheduleServiceDetails.serviceQuantityRemove.map(data => data.group) : []
  const serviceGroupRemoval = !isEmpty(teamScheduleServiceDetails) && teamScheduleServiceDetails.serviceQuantityRemove.length > 0 ? teamScheduleServiceDetails.serviceQuantityRemove.filter(data => data.updateKey == "removed") : []
  const serviceGroupRemovalArray = !isEmpty(serviceGroupRemovalCount) && serviceGroupRemovalCount.length > 0 ? serviceGroupRemovalCount[serviceGroupRemovalCount.length - 1] : []
  console.log(serviceGroupRemoval, "serviceGroupRemoval")
  console.log(serviceGroupRemovalArray, "serviceGroupRemovalArray")
  const removeTeamScheduleService = () => {
    const teamScheduling = {
      leadId: id,
      eventId: teamServiceEventId,
      connectingId: removeServiceNameId,
      updateKey: "removed",
    }

    dispatch(teamSchedulingAction.removeTeamSchedulingService(teamScheduling))
    setTimeout(() => {
      api
        .post("get_event_team_schedule_detils_from_lead", record)
        .then((res) => {
          console.log(res.data, "response")
          setTeamScheduleServiceDetails({
            addLeadService: !isEmpty(res.data.data.addLeadService)
              ? res.data.data.addLeadService
              : [],
            removeLeadService: !isEmpty(res.data.data.removeLeadService)
              ? res.data.data.removeLeadService
              : [],
            serviceQuantityUpdate: !isEmpty(res.data.data.serviceQuantityUpdate)
              ? res.data.data.serviceQuantityUpdate
              : [],
            serviceQuantityRemove: !isEmpty(res.data.data.serviceQuantityRemove)
              ? res.data.data.serviceQuantityRemove
              : [],
          })
          res.data
        })
        .catch((error) => Promise.reject(error))
      // toast.success("Service Removed Successfully", {
      //   position: toast.POSITION.TOP_RIGHT
      // })
    }, 1000)
  }
  // const undoTeamScheduleService = () => {

  // }
  // console.log(removeServiceDetailsObj, "removeServiceDetailsObj")
  console.log(removeServiceName, "removeServiceName")
  console.log(removeServiceListName, "removeServiceListName")
  console.log(removeServiceNameId, "removeServiceNameId")

  // const removeServiceListNameArray = !isEmpty(removeServiceListName) && removeServiceListName
////updateTeamSchedulingService/////////
  // Edit Team Modal  -- Update team schedule service
  const updateTeamScheduleService = () => {
    const addLeadService =
      !isEmpty(teamScheduleServiceDetails) &&
        teamScheduleServiceDetails.addLeadService
        ? teamScheduleServiceDetails.addLeadService.map(
          (data) => data.serviceId
        )
        : []// add connectingId add
    const removeLeadService =
      !isEmpty(teamScheduleServiceDetails) &&
        teamScheduleServiceDetails.removeLeadService
        ? teamScheduleServiceDetails.removeLeadService.map((data) => data.connectingId)
        .filter((id) => id !== null && id !== undefined) 
        : []
    const serviceQuantityRemoveDetails =
      !isEmpty(teamScheduleServiceDetails) &&
        teamScheduleServiceDetails.serviceQuantityRemove
        ? teamScheduleServiceDetails.serviceQuantityRemove.filter(
          (data) => data.updateKey == "removed"
        )
        : []
    const serviceQuantityRemoveDetailsArray =
      serviceQuantityRemoveDetails && serviceQuantityRemoveDetails
        ? serviceQuantityRemoveDetails.map((data) => data.connectingId)
        .filter((id) => id !== null && id !== undefined) 
        : []

    const serviceQuantityRemove =
      serviceQuantityRemoveDetailsArray &&
        serviceQuantityRemoveDetailsArray.length > 0
        ? serviceQuantityRemoveDetailsArray
        : []

    const serviceQuantityUpdate =
      !isEmpty(teamScheduleServiceDetails) &&
        teamScheduleServiceDetails.serviceQuantityUpdate
        ? teamScheduleServiceDetails.serviceQuantityUpdate.map(
          (data) => data.serviceId
        )
        : []

    const addLeadServiceDetails =
      addLeadService.length > 0 && serviceQuantityUpdate.length > 0
        ? addLeadService.concat(serviceQuantityUpdate)
        : addLeadService.length > 0 && serviceQuantityUpdate.length == 0
          ? addLeadService
          : addLeadService.length == 0 && serviceQuantityUpdate.length > 0
            ? serviceQuantityUpdate
            : []
    const removeLeadServiceDetails =
      serviceQuantityRemove.length > 0 && removeLeadService.length > 0
        ? serviceQuantityRemove.concat(removeLeadService)
        : serviceQuantityRemove.length > 0 && removeLeadService.length == 0
          ? serviceQuantityRemove
          : serviceQuantityRemove.length == 0 && removeLeadService.length > 0
            ? removeLeadService
            : []

    console.log(serviceQuantityRemoveDetails, "serviceQuantityRemoveDetails")
    console.log(
      serviceQuantityRemoveDetailsArray,
      "serviceQuantityRemoveDetailsArray"
    )
    // console.log(removeQuantityArrayDetails, "removeQuantityArrayDetails")
    console.log(serviceQuantityRemove, "serviceQuantityRemove")
    console.log(serviceQuantityUpdate, "serviceQuantityUpdate")
    console.log(removeLeadService, "removeLeadService")
    console.log(addLeadServiceDetails, "addLeadServiceDetails")
    console.log(removeLeadServiceDetails, "removeLeadServiceDetails")
    const teamScheduling = {
      leadId: id,
      eventId: teamServiceEventId,
      addService: addLeadServiceDetails,
      removeService: removeLeadServiceDetails,
    }
    console.log(teamScheduling, "UpdateteamSchedulingService")
    dispatch(teamSchedulingAction.updateTeamSchedulingService(teamScheduling))
    setTimeout(() => {
      const eventScheduling = {
        status: "active",
        leadId: id,
        eventId: teamServiceEventId,
      }
      api
        .post("get_all_event_team_schedule", eventScheduling)
        .then((res) => {
          const editTeamScheduling =
            !isEmpty(res.data.data) && res.data.data && res.data.data.length > 0
              ? res.data.data.map((data) => {
                if (data.eventId === teamServiceEventId) {
                  return data
                }
              })
              : []
          const editTeamSchedulingList = !isEmpty(editTeamScheduling)
            ? editTeamScheduling.filter((data) => data !== undefined)
            : []

          // setServiceDetailsData(eventService)
          console.log(editTeamSchedulingList, "editTeamSchedulingList")
          // setTimeout(() => {
          setEditTeamScheduleDetails(editTeamSchedulingList)
          const ticket =
            isEmpty(editTeamSchedulingList) &&
              editTeamSchedulingList &&
              editTeamSchedulingList.length == 0
              ? 0
              : editTeamSchedulingList[0].groupTicket
          // const grouptTicket = !isEmpty(ticket) ? ticket : 0
          setTeamSchedulingDetails(editTeamSchedulingList[0])
          const historyDetails =
            !isEmpty(editTeamSchedulingList) &&
              editTeamSchedulingList.length > 0
              ? editTeamSchedulingList[0]
              : []
          console.log(historyDetails, "historyDetails")
          console.log(ticket, "ticket")

          setCommitHistoryDetails(historyDetails.commitHistory)

          const serviceDetailsSet =
            !isEmpty(editTeamSchedulingList) &&
              editTeamSchedulingList.length > 0
              ? editTeamSchedulingList[0].serviceDetails.map((data, index) => {
                const freelanceTypeId =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].freelanceMainShooterId
                    : ""
                const freelanceTypeName =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].freelanceMainShooterName
                    : ""
                const subFreelanceTypeId =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].freelanceSubShooterId
                    : ""
                const subFreelanceTypeName =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].freelanceSubShooterName
                    : ""
                // const subFreelanceTypeId = !isEmpty(data) && data.teamFreelanceShooter && data.teamFreelanceShooter.length > 0 ? data.teamFreelanceShooter[0].freelanceSubShooterId.subFreelancerName : ""
                const freelanceAmount =
                  !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter[0].amount
                    : ""
                // const subFreelanceTypeId = !isEmpty(data) && data.teamFreelanceShooter.length > 0 ? data.teamFreelanceShooter[0].freelanceSubShooterId : []
                // const freelanceAmount = !isEmpty(data) && data.teamFreelanceShooter.length > 0 ? data.teamFreelanceShooter[0].amount : []
                console.log(freelanceTypeId, "freelanceTypeId")
                console.log(data, "data")
                return {
                  _id: data._id,
                  serviceNumber: data.serviceNo,
                  serviceName: !isEmpty(data.serviceId)
                    ? data.serviceId.serviceName
                    : "",
                  index: index,
                  serviceNameValue: !isEmpty(data.serviceId)
                    ? data.serviceId._id
                    : "",
                  teamType:
                    data.teamType === "Freelancer" ? "Freelancer" : "InHouse",
                  teamTypeId: data.teamType,
                  shooterType: !isEmpty(data.teamEmployeeShooterId)
                    ? `${data.teamEmployeeShooterId.empCode}-${data.teamEmployeeShooterId.name}`
                    : "",
                  shooterTypeId: !isEmpty(data.teamEmployeeShooterId)
                    ? data.teamEmployeeShooterId._id
                    : "",
                  shooterPositionId: !isEmpty(data.shooterPositionId)
                    ? data.shooterPositionId._id
                    : "",
                  shooterPosition: !isEmpty(data.shooterPositionId)
                    ? data.shooterPositionId.name
                    : "",
                  freelancerType: freelanceTypeName,
                  freelancerTypeId: freelanceTypeId,
                  subFreelancerType: subFreelanceTypeName,
                  subFreelancerTypeId: subFreelanceTypeId,
                  freelanceAmount: freelanceAmount,
                  paymentStatus:
                    data.paymentStatus === "free" ? "FREE" : "PAID",
                  paymentStatusId:
                    data.paymentStatus === "free" ? "free" : "paid",
                  uploadInput: data.ticket,
                  vendorType:
                    !isEmpty(subFreelanceTypeId) &&
                      subFreelanceTypeId.length > 0
                      ? "multiple"
                      : "single",
                  uploadInputCount: !isEmpty(data.ticket) ? 1 : 0,
                  // vendorMembers: data.vendorMembers
                }
              })
              : []
          console.log(serviceDetailsSet, "serviceDetailsSet")
          setUploadTicketInput(ticket)
          setServiceDetailsData(serviceDetailsSet)
          // setSubFreelancerListData(subFreelanceTypeId)
          // setServiceDetailDataSet(true)
          // }, 500)
          res.data
        })
        .catch((error) => Promise.reject(error))
      setEditTeamModal(false)
      toast.success("Team Schedule Service Updated Successfully", {
        position: toast.POSITION.TOP_RIGHT,
      })
    }, 1500)
  }

  console.log(teamScheduleServiceDetails, "teamScheduleServiceDetails")

  return (
    <React.Fragment>
      <Container>
        <Row className="quote-head-content mb-4">
          <Col md="9" lg="9" sm="9" className="d-flex flex-row">
            <p className="quote-head">
              Team Scheduling
              <span className="quote-info">
                <i
                  style={{ color: "grey" }}
                  id="quoteInfo1"
                  aria-hidden="true"
                  className="fa fa-info-circle ms-1"
                ></i>
                <UncontrolledTooltip placement="right" target="quoteInfo1">
                  Team Scheduling
                </UncontrolledTooltip>
              </span>
            </p>
            <div style={{ width: "150px", marginRight: "10px" }}>
              <MultiSelect
                value={tableFilterOpt}
                onChange={setTableFilterOpt}
                options={finalCommitOptions}
                labelledBy="Select Event"
                hasSelectAll={true}
                disabled={modeMenu === "EventComplete" ? true : false}
              />
              {finalCommitValidation && tableFilterOpt.length == 0 ? (
                <span
                  style={{
                    fontSize: "10px",
                    color: "red",
                  }}
                >
                  Final Commit field is required
                </span>
              ) : (
                ""
              )}
            </div>
            <div>
              <Button
                type="submit"
                className="btn btn-danger"
                disabled={modeMenu === "EventComplete" ? true : false}
                onClick={() => {
                  if (tableFilterOpt.length > 0) {
                    setFinalCommitModal(true)
                  } else {
                    setFinalCommitValidation(true)
                  }
                }}
              >
                Final Commit
              </Button>
            </div>
          </Col>
        </Row>
        <div className="mb-4">
          {!isEmpty(collapseData) && collapseData.length > 0 ? (
            collapseData.map((data, idx) => {
              var serviceId = data.leadEventId

              const commitStatus =
                !isEmpty(event_team_scheduling) &&
                  event_team_scheduling.length > 0
                  ? event_team_scheduling.find(
                    (team) => team.eventId === data.leadEventId
                  )
                  : []

              console.log(serviceId, "id from service")
              console.log(commitStatus, "commitStatus")
              return (
                <Row
                  className="question-card-content mb-1"
                  style={{
                    padding: "0px 4px",
                  }}
                  key={data.leadEventId}
                >
                  <Col>
                    <div className="d-flex flex-row ">
                      <p
                        style={{
                          fontSize: "15px",
                          marginBottom: "12px",
                          marginRight: "8px",
                          // padding: "0px 8px",
                          fontWeight: 550,
                          marginTop: "10px",
                        }}
                      >
                        {data.eventNo}
                        {/* Event */}
                      </p>

                      {data.isUpdate ? (
                        <div className="mx-3" style={{ marginTop: "10px" }}>
                          {editModal === true ? (
                            <Button
                              type="submit"
                              style={{ fontSize: "8px" }}
                              onClick={() => {
                                if (data.leadEventId) {
                                  setCollapseDetails(data)
                                  // editTeamEvents(data)
                                  setEditModal(false)
                                  // setLeadEventId("")
                                  // setServiceDetailsData("")
                                }
                                // if (data.leadEventId === commitStatus.eventId) {
                                // setEditTeamScheduleDetails(event_team_scheduling)
                                // }
                              }}
                              className={"btn btn-success"}
                            >
                              <i className="fas fa-edit icon-btn"></i>
                            </Button>
                          ) : (
                            <Button
                              type="submit"
                              style={{ fontSize: "8px" }}
                              onClick={() => {
                                if (data.leadEventId) {
                                  setCollapseDetails(data)
                                  editTeamEvents(data)
                                  setEditModal(true)
                                
                                  const newCheckboxStates = [...checkboxStates]
                                  if (data.isMainEvent !== undefined) {
                                      newCheckboxStates[idx] = data.isMainEvent
                                  } else {
                                      newCheckboxStates[idx] = false
                                  }
                                  setCheckboxStates(newCheckboxStates)
                                  console.log(newCheckboxStates,"newCheck")
                                  // if (data.isMainEvent == true || !isEmpty(teamSchedulingDetails)
                                  //   && teamSchedulingDetails.eventDetails.isMainEvent == true) {
                                  //   setIsMainEvent(true)
                                  // } else {
                                  //   setIsMainEvent(false)
                                  // }
                                }
                                //----------------------------

                              }}
                              className={"btn btn-success"}
                            >
                              <i className="fas fa-edit icon-btn"></i>
                            </Button>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      {!isEmpty(data) && data.isCommitted === true ? (
                        <div
                          style={{
                            marginTop: "12.5px",
                          }}
                        >
                          {" "}
                          <button
                            style={{
                              background: "#34c38f",
                              border: "none",
                              // cursor: "pointer",
                              fontSize: "12px",
                              color: "white",
                              padding: "2px 2px",
                              borderRadius: "4px",
                            }}
                          >
                            {"Committed"}
                          </button>
                        </div>
                      ) : (
                        <div
                          style={{
                            marginTop: "12.5px",
                          }}
                        >
                          <button
                            style={{
                              background: "#f34848",
                              border: "none",
                              // cursor: "pointer",
                              fontSize: "12px",
                              color: "white",
                              padding: "2px 2px",
                              borderRadius: "4px",
                            }}
                          >
                            {"Not Committed"}
                          </button>
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col>
                    {/* {modeMenu === "EventComplete" ? (
                      ""
                    ) : ( */}
                    <div
                      style={{
                        color: "#291213",
                        height: "22px",
                        width: "max-content",
                        textAlign: "center",
                        cursor: "pointer",
                        fontSize: "24px",
                        marginTop: "10px",
                        float: "right",
                        display: "flex",
                      }}
                      className={
                        data.isUpdate === true ? "disabled-button" : ""
                      }
                      aria-controls="example-collapse-text"
                      aria-expanded={open}
                      onClick={() => {
                        if (data.leadEventId) {
                          setCollapseDetails(data)
                          setCollapseServiceDetails(data)
                          setOpen(!open)
                          setLeadEventId(data.leadEventId)
                          setServiceOpen(true)
                          // setEditModal(!editModal)
                          setPageLoad(!pageLoad)
                        }
                      }}
                    >
                      <i className="fas fa-angle-down"></i>
                    </div>
                    {/* )} */}
                  </Col>
                  <Collapse
                    in={
                      (data.leadEventId === collapseDetails.leadEventId &&
                        open) ||
                      (data.leadEventId === collapseDetails.leadEventId &&
                        editModal)
                    }

                  >
                    <div id="example-collapse-text">
                      <Col>
                        <Row>
                          <Col md="2" lg="2" sm="2" className="mt-3">
                            <Card
                              style={{
                                border: "2px solid rgb(239, 242, 247)",
                                textAlign: "center",
                                boxShadow:
                                  "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
                              }}
                            >
                              <CardBody>
                                <Col sm="12" md="12" lg="12">
                                  <div
                                    style={{
                                      fontSize: "22px",
                                      fontWeight: "bold",
                                      flex: "display",
                                    }}
                                  >
                                    {" "}
                                    EVENT
                                  </div>
                                </Col>

                                <h1
                                  style={{
                                    color: "#E40D8C",
                                    textAlign: "center",
                                  }}
                                >
                                  {!isEmpty(collapseDetails)
                                    ? collapseDetails.eventNo.split("Event")
                                    : ""}
                                </h1>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col md="10" lg="10" sm="10" className="mb-2">
                            <Row className="mt-2">
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  {"Event Name :"}
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.eventName) || open
                                    ? collapseDetails.eventName
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.eventDetails
                                        .eventName
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  {"Date :"}
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.eventDate) || open
                                    ? moment(collapseDetails.eventDate).format(
                                      "DD-MM-YYYY"
                                    )
                                    : !isEmpty(teamSchedulingDetails)
                                      ? moment(
                                        teamSchedulingDetails.eventDetails
                                          .eventDate
                                      ).format("DD-MM-YYYY")
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  {"Start Time :"}
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.startTime) || open
                                    ? eventStartTimeData
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.eventDetails
                                        .startTime
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  End Time:
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.endTime) || open
                                    ? eventEndTimeData
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.eventDetails.endTime
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Venue Name :
                                </p>
                                <p
                                  style={{
                                    fontWeight: "550",
                                    // width: "max-content",
                                  }}
                                >
                                  {!isEmpty(collapseDetails.venueName) || open
                                    ? collapseDetails.venueName
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.eventDetails
                                        .venueName
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Venue Location:
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.venueLocation) ||
                                    open
                                    ? collapseDetails.venueLocation
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.eventDetails
                                        .venueLocation
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Food :
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.food) || open
                                    ? collapseDetails.food
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.eventDetails.food
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Travel :
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.travelStay) || open
                                    ? collapseDetails.travelStay
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.eventDetails
                                        .travelStay
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Crew Assembly :
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.crewAssemblyTime) ||
                                    open
                                    ? crewAssemblyTimeData
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.eventDetails
                                        .crewAssemblyTime
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3">
                                <p
                                  style={{
                                    fontWeight: "450",
                                    marginBottom: "-1px",
                                  }}
                                >
                                  Crowd Strength :
                                </p>
                                <p style={{ fontWeight: "550" }}>
                                  {!isEmpty(collapseDetails.crowdStrength) ||
                                    open
                                    ? collapseDetails.crowdStrength
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.eventDetails
                                        .crowdStrength
                                      : "--"}
                                </p>
                              </Col>
                              <Col md="3" lg="3" sm="3" className="d-flex mt-3"
                              >
                                <div className="d-flex flex-row">
                                  <Input
                                    type="checkbox"
                                    name={`isMainEvent-${idx}`} // Use index here
                                    checked={checkboxStates[idx] || false} // Access checkbox state using index
                                    onChange={() => handleCheckboxChange(idx)} // Pass index to the handler
                                  />

                                  <Label className="event-label mx-2">
                                    Is Main Event
                                  </Label>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <Row className="mt-3 mb-2">
                          <Col sm="12" md="12" lg="12">
                            <div className="d-flex flex-row justify-content-end">
                              <Button
                                className={"btn btn-success"}
                                style={{ marginRight: "6px" }}
                                onClick={() => {
                                  setEditTeamModal(true)
                                  setTeamServiceEventId(data.leadEventId)
                                }}
                              >
                                {"Edit"}
                              </Button>
                              <Button
                                className={
                                  !isEmpty(data) && data.isCommitted === true
                                    ? "btn btn-success"
                                    : "btn btn-danger"
                                }
                                style={{ marginRight: "6px" }}
                                onClick={() => {
                                  // if (
                                  //   data.leadEventId ===
                                  //   collapseDetails.leadEventId
                                  // ) {
                                  setEventCommit(true)
                                  setEventId(data.leadEventId)
                                  // }
                                }}
                                disabled={
                                  modeMenu === "EventComplete" ? true : false
                                }
                              >
                                {!isEmpty(data) && data.isCommitted === true
                                  ? "Committed"
                                  : "Final Commit"}
                              </Button>
                              <div
                                style={{
                                  marginLeft: "-13px",
                                  marginTop: "-8px",
                                  marginRight: "6px",
                                }}
                              >
                                <p
                                  style={{
                                    color: "#fffff",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                  }}
                                  className={"badge bg-warning rounded-pill"}
                                  onClick={() => setCommitHistoryModal(true)}
                                >
                                  {!isEmpty(commitHistoryDetails)
                                    ? commitHistoryDetails.length
                                    : !isEmpty(teamSchedulingDetails)
                                      ? teamSchedulingDetails.commitHistory.length
                                      : 0}
                                </p>
                              </div>
                              <Button
                                className={
                                  modeMenu === "EventComplete"
                                    ? "disabled-button btn btn-warning"
                                    : "btn btn-warning"
                                }
                                style={{ marginRight: "6px" }}
                                onClick={() => {
                                  setAgentVaccancyModal(true)
                                  setFullscreen(true)
                                }}
                              >
                                Agent Vacancy
                              </Button>
                              <div
                                className={
                                  modeMenu === "EventComplete"
                                    ? "disabled-button file btn btn-success"
                                    : "file btn btn-success"
                                }
                                style={{
                                  overflow: "hidden",
                                  position: "relative",
                                  marginRight: "5px",
                                }}
                              >
                                <i
                                  className="fas fa-paperclip"
                                  style={{ marginRight: "5px" }}
                                ></i>
                                Group Ticket
                                <Input
                                  type="file"
                                  name="uploadTicketInput"
                                  accept="application/pdf, audio/mp3 , image/jpeg"
                                  // id="upload-btn"
                                  multiple
                                  onChange={(e) => uploadTicketChange(e)}
                                  style={{
                                    position: "absolute",
                                    fontSize: "50px",
                                    opacity: 0,
                                    right: 0,
                                    top: 0,
                                  }}
                                />
                              </div>
                              <span
                                style={{
                                  fontSize: "10px",
                                  position: "absolute",
                                  top: "-7px",
                                  right: "115px",
                                }}
                                className="badge bg-warning rounded-pill"
                              >
                                {!isEmpty(uploadTicketInput)
                                  ? uploadTicketInput.length
                                  : // : teamSchedulingDetails.groupTicket.length > 0
                                  // ? teamSchedulingDetails.groupTicket
                                  0}
                              </span>
                              <Button
                                className={
                                  modeMenu === "EventComplete"
                                    ? "disabled-button btn btn-info"
                                    : "btn btn-info"
                                }
                                onClick={() => addServiceDetails()}
                              >
                                Add Service
                              </Button>
                            </div>
                          </Col>
                        </Row>
                        {/* //Modal */}

                        {editTeamModal && (
                          <Modal
                            show={editTeamModal}
                            onHide={handleEditTeamModal}
                            size="lg"

                          // fullscreen={fullscreen}
                          >
                            <Modal.Header
                              style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                            >
                              Edit Team Scheduling
                            </Modal.Header>
                            <Modal.Body>
                              <Col md="12" lg="12" xl="12">
                                <Table striped bordered>
                                  <thead>
                                    <tr style={{ fontSize: "12px" }}>
                                      {/* <th>S.No</th> */}
                                      <th style={{ width: "20%" }}>
                                        Service Name
                                      </th>
                                      <th style={{ width: "10%" }}>Type</th>
                                      <th style={{ width: "22%" }}>
                                        Shooter Name
                                      </th>
                                      <th style={{ width: "20%" }}>
                                        Freelancer Name
                                      </th>
                                      <th style={{ width: "10%" }}>Payment</th>
                                      <th style={{ width: "18%" }}>#</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {!isEmpty(teamScheduleServiceDetails) &&
                                      teamScheduleServiceDetails.addLeadService
                                        .length > 0 &&
                                      teamScheduleServiceDetails.addLeadService.map(
                                        (service, index) => {
                                          //Sub freelancer dropdown
                                          console.log(index, "index")

                                          return (
                                            <tr key={index}>
                                              <td>{service.serviceName}</td>
                                              <td>
                                                {!isEmpty(service.teamType)
                                                  ? service.teamType
                                                  : "--"}
                                              </td>
                                              <td>
                                                {!isEmpty(
                                                  service.teamEmployeeShooterName
                                                )
                                                  ? service.teamEmployeeShooterName
                                                  : "--"}
                                              </td>
                                              <td>
                                                {!isEmpty(
                                                  service.freelanceMainShooterName
                                                )
                                                  ? service.freelanceMainShooterName
                                                  : "--"}
                                              </td>
                                              <td>
                                                {" "}
                                                {!isEmpty(service.paymentStatus)
                                                  ? service.paymentStatus
                                                  : "--"}
                                              </td>
                                              <td>
                                                <Badge className="bg-success badge-soft-success p-2">
                                                  Service Added
                                                </Badge>
                                              </td>
                                            </tr>
                                          )
                                        }
                                      )}

                                    {
                                      !isEmpty(teamScheduleServiceDetails) &&
                                      teamScheduleServiceDetails
                                        .removeLeadService.length > 0 &&
                                      teamScheduleServiceDetails.removeLeadService.map(
                                        (service, index) => {
                                          //Sub freelancer dropdown
                                          console.log(index, "index")

                                          return (
                                            <tr key={index}>
                                              <td>{service.serviceName}</td>
                                              <td>
                                                {!isEmpty(service.teamType)
                                                  ? service.teamType
                                                  : "--"}
                                              </td>
                                              <td>
                                                {!isEmpty(
                                                  service.teamEmployeeShooterName
                                                )
                                                  ? service.teamEmployeeShooterName
                                                  : "--"}
                                              </td>
                                              <td>
                                                {!isEmpty(
                                                  service.freelanceMainShooterName
                                                )
                                                  ? service.freelanceMainShooterName
                                                  : "--"}
                                              </td>
                                              <td>
                                                {" "}
                                                {!isEmpty(
                                                  service.paymentStatus
                                                )
                                                  ? service.paymentStatus
                                                  : "--"}
                                              </td>

                                              <td>
                                                <Badge className="bg-danger badge-soft-danger p-2">
                                                  Service Removed
                                                </Badge>
                                              </td>
                                            </tr>
                                          )
                                        }
                                      )
                                      // : (
                                      //   <tr key={0}>
                                      //     <td
                                      //       colSpan={6}
                                      //       className="text-align-center"
                                      //     >
                                      //       No Records Found..
                                      //     </td>
                                      //   </tr>
                                      // )
                                    }

                                    {
                                      !isEmpty(teamScheduleServiceDetails) &&
                                      teamScheduleServiceDetails
                                        .serviceQuantityRemove.length > 0 &&
                                      teamScheduleServiceDetails.serviceQuantityRemove.map(
                                        (service, index) => {
                                          //Sub freelancer dropdown
                                          console.log(index, "index")
                                          //   const removedService = removeServiceListName.length > 0 && removeServiceListName.find(data => data== service.serviceName )
                                          //   &&
                                          //  removeServiceNameId !=
                                          //    service._id &&
                                          //  serviceGroup.length > 0 && serviceGroup.find(data=> data != service.group)  &&
                                          //  removeServiceName ==
                                          //    "Remove"
                                          //     &&
                                          //  service.updateKey !=
                                          //    "removed"
                                          return (
                                            <tr key={index}>
                                              <td>{service.serviceName}</td>

                                              <td>
                                                {!isEmpty(service.teamType)
                                                  ? service.teamType
                                                  : "--"}
                                              </td>
                                              <td>
                                                {!isEmpty(
                                                  service.teamEmployeeShooterName
                                                )
                                                  ? service.teamEmployeeShooterName
                                                  : "--"}
                                              </td>
                                              <td>
                                                {!isEmpty(
                                                  service.freelanceMainShooterName
                                                )
                                                  ? service.freelanceMainShooterName
                                                  : "--"}
                                              </td>
                                              <td>
                                                {" "}
                                                {!isEmpty(
                                                  service.paymentStatus
                                                )
                                                  ? service.paymentStatus
                                                  : "--"}
                                              </td>
                                              {service.quantityNeedToRemove ==
                                                1 ||
                                                service.quantityNeedToRemove ==
                                                2 ||
                                                service.quantityNeedToRemove ==
                                                3 ? (
                                                <td className="d-flex flex-row">
                                                  {service.updateKey ==
                                                    "removed" ? (
                                                    ""
                                                  ) : (
                                                    <Button
                                                      className={
                                                        (removeServiceListName.length >
                                                          0 &&
                                                          removeServiceListName.find(
                                                            (data) =>
                                                              data ==
                                                              service.serviceName
                                                          ) &&
                                                          // removeServiceNameId !=
                                                          //   service._id &&
                                                          // serviceGroup.length > 0 && serviceGroup.find(data=> data != service.group)  &&
                                                          removeServiceArrayDataId.length >
                                                          0 &&
                                                          removeServiceArrayDataId.find(
                                                            (data) =>
                                                              data !=
                                                              service._id
                                                          ) &&
                                                          removeServiceName ==
                                                          "Remove" &&
                                                          service.updateKey !=
                                                          "removed") ||
                                                          (removeServiceListName.length >
                                                            0 &&
                                                            removeServiceListName.find(
                                                              (data) =>
                                                                data ==
                                                                service.serviceName
                                                            ) &&
                                                            // removeServiceNameId !=
                                                            //   service._id &&
                                                            // serviceGroup.length > 0 && serviceGroup.find(data=> data != service.group)  &&
                                                            removeServiceArrayDataId.length >
                                                            0 &&
                                                            removeServiceArrayDataId.find(
                                                              (data) =>
                                                                data !=
                                                                service._id
                                                            ) &&
                                                            removeServiceName ==
                                                            "Undo" &&
                                                            service.updateKey !=
                                                            "removed")
                                                          ?
                                                          "btn btn-danger disabled-button"
                                                          :
                                                          removeServiceName ==
                                                            "Undo" ||
                                                            service.updateKey ==
                                                            "default"
                                                            ? // || service.updateKey == "default" && removeServiceNameId !=
                                                            // service._id
                                                            "btn btn-danger"
                                                            : "btn btn-danger"
                                                      }
                                                      style={{
                                                        padding: "5px 8px",
                                                      }}
                                                      onClick={() => {
                                                        removeServiceListName.push(
                                                          service.serviceName
                                                        )

                                                        removeServiceArrayDataId.push(
                                                          service._id
                                                        )
                                                        serviceGroup.push(
                                                          service.group
                                                        )
                                                        setRemoveServiceNameId(
                                                          service.connectingId
                                                        )
                                                        setRemoveTeamServiceEvent(
                                                          true
                                                        )
                                                      }}
                                                    >
                                                      Remove{" "}
                                                      {`(${
                                                        // removeServiceNameId !=
                                                        //   service._id && removeServiceListName !=
                                                        //   service.serviceName &&
                                                        // removeServiceName ==
                                                        //   "Remove" &&
                                                        // service.updateKey !=
                                                        //   "removed"
                                                        //   ? 0
                                                        //   :
                                                        service.quantityNeedToRemove
                                                        })`}
                                                    </Button>
                                                  )}

                                                  {service.updateKey ==
                                                    "removed" ? (
                                                    <Button
                                                      className="btn btn-danger mx-1"
                                                      onClick={() => {
                                                        setRemoveServiceNameId(
                                                          service.connectingId
                                                        )
                                                        setRemoveServiceDetailsObjId(
                                                          ""
                                                        )
                                                        setUndoServiceListName(
                                                          service.serviceName
                                                        )
                                                        setUndoServiceConfirmation(
                                                          true
                                                        )
                                                        // setRemoveTeamServiceEvent(false)
                                                      }}
                                                    >
                                                      <i className="fa fa-undo"></i>{" "}
                                                      Undo
                                                    </Button>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                              ) : (
                                                ""
                                              )}
                                            </tr>
                                          )
                                        }
                                      )
                                      // : (
                                      //   <tr key={0}>
                                      //     <td
                                      //       colSpan={6}
                                      //       className="text-align-center"
                                      //     >
                                      //       No Records Found..
                                      //     </td>
                                      //   </tr>
                                      // )
                                    }
                                    {
                                      !isEmpty(teamScheduleServiceDetails) &&
                                      teamScheduleServiceDetails
                                        .serviceQuantityUpdate.length > 0 &&
                                      teamScheduleServiceDetails.serviceQuantityUpdate.map(
                                        (service, index) => {
                                          //Sub freelancer dropdown
                                          console.log(index, "index")

                                          return (
                                            <tr key={index}>
                                              <td>{service.serviceName}</td>
                                              <td>
                                                {!isEmpty(service.teamType)
                                                  ? service.teamType
                                                  : "--"}
                                              </td>
                                              <td>
                                                {!isEmpty(
                                                  service.teamEmployeeShooterName
                                                )
                                                  ? service.teamEmployeeShooterName
                                                  : "--"}
                                              </td>
                                              <td>
                                                {!isEmpty(
                                                  service.freelanceMainShooterName
                                                )
                                                  ? service.freelanceMainShooterName
                                                  : "--"}
                                              </td>
                                              <td>
                                                {!isEmpty(
                                                  service.paymentStatus
                                                )
                                                  ? service.paymentStatus
                                                  : "--"}
                                              </td>

                                              <td>
                                                <Badge className="bg-info badge-soft-info p-2">
                                                  Qty Added
                                                </Badge>
                                              </td>
                                            </tr>
                                          )
                                        }
                                      )
                                      // : (
                                      //   <tr key={0}>
                                      //     <td
                                      //       colSpan={6}
                                      //       className="text-align-center"
                                      //     >
                                      //       No Records Found..
                                      //     </td>
                                      //   </tr>
                                      // )
                                    }
                                    {teamScheduleServiceDetails.addLeadService
                                      .length == 0 &&
                                      teamScheduleServiceDetails.removeLeadService
                                        .length == 0 &&
                                      teamScheduleServiceDetails
                                        .serviceQuantityRemove.length == 0 &&
                                      teamScheduleServiceDetails
                                        .serviceQuantityUpdate.length == 0 ? (
                                      <tr>
                                        <td
                                          colSpan={6}
                                          className="text-align-center"
                                        >
                                          No Records Found..
                                        </td>
                                      </tr>
                                    ) : (
                                      ""
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                className="btn btn-danger"
                                onClick={() => handleEditTeamModal()}
                              >
                                Close
                              </Button>
                              <Button
                                type="button"
                                className={
                                  teamScheduleServiceDetails.addLeadService
                                    .length > 0 && removeServiceArrayDataId.length > 0 || teamScheduleServiceDetails.addLeadService
                                      .length > 0 || teamScheduleServiceDetails.removeLeadService
                                        .length > 0 || teamScheduleServiceDetails.removeLeadService && removeServiceArrayDataId.length > 0
                                          .length > 0 || teamScheduleServiceDetails.serviceQuantityUpdate.length > 0 || teamScheduleServiceDetails.serviceQuantityUpdate
                                            .length > 0 && removeServiceArrayDataId.length > 0
                                    ? "btn btn-success"
                                    : serviceGroupRemovalArray == serviceGroupRemoval.length && removeServiceArrayDataId.length > 0 ? "btn btn-success" : "btn btn-success disabled-button"
                                }
                                onClick={() => {
                                  setUpdateServiceConfirmation(true)
                                }}
                              >
                                Update
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        )}
                        {/* {Remove event modal} */}
                        {removeTeamServiceEvent && (
                          <Modal
                            show={removeTeamServiceEvent}
                            onHide={handleRemoveServiceEvent}
                            size="md"
                            style={{
                              background: "#00000020",
                            }}
                          // fullscreen={fullscreen}
                          >
                            <Modal.Header
                              style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                            >
                              Remove Service
                            </Modal.Header>
                            <Modal.Body>
                              Do you want to Remove the Service ?
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                className="btn btn-danger"
                                onClick={() => {
                                  // setRemoveServiceName("Undo")
                                  removeServiceListName.length > 0
                                    ? // ? removeServiceListName.pop()
                                    removeServiceListName.pop(
                                      (data) => data == undoServiceListName
                                    )
                                    : removeServiceListName
                                  removeServiceArrayDataId.length > 0
                                    ? // ? removeServiceArrayDataId.pop()
                                    removeServiceArrayDataId.pop(
                                      (data) => data == removeServiceNameId
                                    )
                                    : removeServiceArrayDataId
                                  setRemoveTeamServiceEvent(false)
                                }}
                              >
                                Cancel
                              </Button>
                              <Button
                                type="button"
                                className="btn btn-success"
                                onClick={() => {
                                  setRemoveServiceName("Remove")
                                  removeTeamScheduleService()
                                  setRemoveTeamServiceEvent(false)
                                }}
                              >
                                Remove
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        )}
                        {/* {Remove event modal} */}
                        {updateServiceConfirmation && (
                          <Modal
                            show={updateServiceConfirmation}
                            onHide={handleRemoveServiceConfirmation}
                            size="md"
                            style={{
                              background: "#00000020",
                            }}
                          // fullscreen={fullscreen}
                          >
                            <Modal.Header
                              style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                            >
                              Update Confirmation
                            </Modal.Header>
                            <Modal.Body>
                              Are you sure you want to update the Service ?
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                className="btn btn-danger"
                                onClick={() => {
                                  // setRemoveServiceName("Undo")
                                  setUpdateServiceConfirmation(false)
                                }}
                              >
                                Cancel
                              </Button>
                              <Button
                                type="button"
                                className="btn btn-success"
                                onClick={() => {
                                  updateTeamScheduleService()
                                  handleEditTeamModal()
                                  setUpdateServiceConfirmation(false)
                                }}
                              >
                                Confirm
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        )}
                        {undoServiceConfirmation && (
                          <Modal
                            show={undoServiceConfirmation}
                            onHide={handleUndoServiceConfirmation}
                            size="md"
                            style={{
                              background: "#00000020",
                            }}
                          // fullscreen={fullscreen}
                          >
                            <Modal.Header
                              style={{
                                backgroundColor: "#E40D8C",
                                color: "white",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                            >
                              Undo Confirmation
                            </Modal.Header>
                            <Modal.Body>
                              Are you sure you want to undo the Service Remove ?
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                className="btn btn-danger"
                                onClick={() => {
                                  // setRemoveServiceName("Undo")
                                  handleUndoServiceConfirmation()
                                }}
                              >
                                Cancel
                              </Button>
                              <Button
                                type="button"
                                className="btn btn-success"
                                onClick={() => {
                                  // undoTeamScheduleService()
                                  setRemoveServiceName("Undo")
                                  removeServiceListName.length > 0
                                    ? // ? removeServiceListName.pop()
                                    removeServiceListName.pop(
                                      (data) => data == undoServiceListName
                                    )
                                    : removeServiceListName
                                  removeServiceArrayDataId.length > 0
                                    ? // ? removeServiceArrayDataId.pop()
                                    removeServiceArrayDataId.pop(
                                      (data) => data == removeServiceNameId
                                    )
                                    : removeServiceArrayDataId
                                  const teamScheduling = {
                                    leadId: id,
                                    eventId: teamServiceEventId,
                                    connectingId: removeServiceNameId,
                                    updateKey: "undo",
                                  }

                                  dispatch(
                                    teamSchedulingAction.removeTeamSchedulingService(
                                      teamScheduling
                                    )
                                  )
                                  setTimeout(() => {
                                    api
                                      .post(
                                        "get_event_team_schedule_detils_from_lead",
                                        record
                                      )
                                      .then((res) => {
                                        console.log(res.data, "response")
                                        setTeamScheduleServiceDetails({
                                          addLeadService: !isEmpty(
                                            res.data.data.addLeadService
                                          )
                                            ? res.data.data.addLeadService
                                            : [],
                                          removeLeadService: !isEmpty(
                                            res.data.data.removeLeadService
                                          )
                                            ? res.data.data.removeLeadService
                                            : [],
                                          serviceQuantityUpdate: !isEmpty(
                                            res.data.data.serviceQuantityUpdate
                                          )
                                            ? res.data.data
                                              .serviceQuantityUpdate
                                            : [],
                                          serviceQuantityRemove: !isEmpty(
                                            res.data.data.serviceQuantityRemove
                                          )
                                            ? res.data.data
                                              .serviceQuantityRemove
                                            : [],
                                        })
                                        res.data
                                      })
                                      .catch((error) => Promise.reject(error))
                                    // toast.success("Service Removed Successfully", {
                                    //   position: toast.POSITION.TOP_RIGHT
                                    // })
                                  }, 1000)
                                  handleUndoServiceConfirmation()
                                }}
                              >
                                Confirm
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        )}

                        <Row className="h-100 mb-5">
                          <Col md="12" lg="12" xl="12">
                            <Table striped bordered>
                              <thead>
                                <tr style={{ fontSize: "10px" }}>
                                  {/* <th>S.No</th> */}
                                  <th style={{ width: "22%" }}>Service Name</th>
                                  <th style={{ width: "10%" }}>Service No</th>
                                  <th style={{ width: "15%" }}>Type</th>
                                  <th style={{ width: "35%" }}>Shooter Name</th>
                                  <th>History</th>
                                  <th style={{ width: "13%" }}>Payment</th>
                                  <th style={{ width: "10%" }}>Ticket</th>
                                  {/* {removeService
                                   ? (
                                    <th style={{ width: "10%" }}>#</th>
                                  ) : (
                                    ""
                                  )} */}
                                </tr>
                              </thead>
                              <tbody>
                                {!isEmpty(serviceDetailsData) ? (
                                  serviceDetailsData.map((service, index) => {
                                    //Sub freelancer dropdown
                                    console.log(index, "index")
                                    const subFreelancerList =
                                      !isEmpty(records) && records.length > 0
                                        ? records.map((data) => {
                                          if (
                                            data.freelancerId ===
                                            service.freelancerTypeId
                                          )
                                            return {
                                              _id: data._id,
                                              name: data.name,
                                              paymentDetails:
                                                data.paymentDetails,
                                            }
                                        })
                                        : []
                                    const subFreelancerData = !isEmpty(
                                      subFreelancerList
                                    )
                                      ? subFreelancerList.filter(
                                        (data) => data !== undefined
                                      )
                                      : []
                                    const createFreelanceOptions = (array) => {
                                      const options = []
                                      !isEmpty(array) &&
                                        array.forEach((element) => {
                                          let obj = {}
                                          obj.value = element._id
                                          obj.label = element.name
                                          obj.paymentDetails =
                                            element.paymentDetails

                                          options.push(obj)
                                        })
                                      return options
                                    }
                                    const subFreelancerListOptions =
                                      createFreelanceOptions(subFreelancerData)

                                    console.log(
                                      subFreelancerList,
                                      "subFreelancerList"
                                    )
                                    console.log(
                                      subFreelancerListOptions,
                                      "subFreelancerListOptions"
                                    )

                                    const serviceTeamOptions =
                                      !isEmpty(teamOptions) &&
                                        teamOptions.length > 0
                                        ? teamOptions.filter(
                                          (data) => data.label == "InHouse"
                                        )
                                        : []
                                    return (
                                      <tr
                                        key={index}
                                        style={{
                                          background:
                                            data.isAlter == true
                                              ? "#fd8301b3"
                                              : "",
                                          color:
                                            data.isAlter == true ? "white" : "",
                                        }}
                                      >
                                        <td style={{ textAlign: "center" }}>
                                          <Select
                                            name="serviceNameValue"
                                            value={
                                              service.serviceNameValue
                                                ? {
                                                  value:
                                                    service.serviceNameValue,
                                                  label: service.serviceName,
                                                }
                                                : ""
                                            }
                                            options={serviceListOptions}
                                            isDisabled={
                                              modeMenu === "EventComplete"
                                                ? true
                                                : false
                                            }
                                            onChange={(e) =>
                                              modalChange(
                                                e,
                                                index,
                                                "serviceNameValue",
                                                serviceId
                                              )
                                            }
                                            placeholder="Select Service Name"
                                            classNamePrefix="select2-selection"
                                          />

                                          {simpleValidator.current.message(
                                            "serviceId",
                                            service.serviceNameValue,
                                            "required"
                                          )}
                                        </td>
                                        <td>
                                          {"CAM" + " 0"}
                                          {index + 1}
                                        </td>
                                        <td>
                                          <Select
                                            // type="text"
                                            name="teamTypeId"
                                            value={
                                              service.teamTypeId
                                                ? {
                                                  value: service.teamTypeId,
                                                  label: service.teamType,
                                                }
                                                : ""
                                            }
                                            options={
                                              service.teamTypeChoose ==
                                                "InHouse"
                                                ? serviceTeamOptions
                                                : teamOptions
                                            }
                                            onChange={(e) =>
                                              modalChange(
                                                e,
                                                index,
                                                "teamTypeId",
                                                serviceId
                                              )
                                            }
                                            isDisabled={
                                              modeMenu === "EventComplete"
                                                ? true
                                                : false
                                            }
                                            placeholder="Type"
                                            classNamePrefix="select2-selection"
                                          />
                                        </td>
                                        <td>
                                          <>
                                            <Row className="d-flex flex-row">
                                              {service.teamTypeId ===
                                                "Freelancer" ? (
                                                <Col md="6" xl="6" lg="6">
                                                  <Select
                                                    name="freelancerTypeId"
                                                    value={
                                                      service.freelancerTypeId
                                                        ? {
                                                          value:
                                                            service.freelancerTypeId,
                                                          label:
                                                            service.freelancerType,
                                                        }
                                                        : ""
                                                    }
                                                    isDisabled={
                                                      modeMenu ===
                                                        "EventComplete"
                                                        ? true
                                                        : false
                                                    }
                                                    placeholder="Select Freelancer"
                                                    onChange={(e) =>
                                                      modalChange(
                                                        e,
                                                        index,
                                                        "freelancerTypeId",
                                                        serviceId
                                                      )
                                                    }
                                                    styles={style}
                                                    className={
                                                      !isEmpty(
                                                        service.teamTypeId
                                                      )
                                                        ? ""
                                                        : "disabled-button"
                                                    }
                                                    classNamePrefix="select2-selection"
                                                    options={
                                                      freelancerOptions
                                                        ? freelancerOptions
                                                        : []
                                                    }
                                                  />
                                                </Col>
                                              ) : (
                                                <>
                                                  <Col md="10" xl="10" lg="10">
                                                    <Select
                                                      name="shooterTypeId"
                                                      value={
                                                        service.shooterTypeId
                                                          ? {
                                                            value:
                                                              service.shooterTypeId,
                                                            label:
                                                              service.shooterType,
                                                          }
                                                          : ""
                                                      }
                                                      isDisabled={
                                                        modeMenu ===
                                                          "EventComplete" ||
                                                          isEmpty(
                                                            service.teamTypeId
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      placeholder="Shooter"
                                                      onChange={(e) => {
                                                        modalChange(
                                                          e,
                                                          index,
                                                          "shooterTypeId",
                                                          serviceId
                                                        )
                                                        // if (
                                                        //   data.leadEventId ===
                                                        //   collapseDetails.leadEventId
                                                        // ) {
                                                        //   setEmployeeId(e.value)
                                                        // }
                                                      }}
                                                      styles={style}
                                                      classNamePrefix="select2-selection"
                                                      options={employeeOptions}
                                                    />
                                                  </Col>
                                                  <Col md="2" xl="2" lg="2">
                                                    <i
                                                      className={
                                                        !isEmpty(
                                                          service.teamTypeId
                                                        )
                                                          ? "fas fa-eye"
                                                          : modeMenu ===
                                                            "EventComplete"
                                                            ? "fas fa-eye disabled-button"
                                                            : "fas fa-eye disabled-button"
                                                      }
                                                      style={{
                                                        color: "#50a5f1",
                                                        fontSize: "15px",
                                                        marginTop: "10px",
                                                      }}
                                                      onClick={() => {
                                                        setAgentVaccancyModal(
                                                          true
                                                        )
                                                        setVacancyServiceDetails(
                                                          serviceDetailsData
                                                        )
                                                        setVacancyId(
                                                          service._id
                                                        )
                                                        setVacancyIndex(
                                                          service.index
                                                        )
                                                        setSelectedAgentData(
                                                          service.shooterTypeId
                                                        )
                                                        dispatch(
                                                          teamSchedulingAction.loadAgentOfficeVacancy(
                                                            {
                                                              month: eventMonth,
                                                              year: eventYear,
                                                              // departmentId:
                                                              //   service.departmentId,
                                                              // employeeId:
                                                              //   service.shooterTypeId,
                                                            }
                                                          )
                                                        )
                                                        setOfficeSelectionDetails(
                                                          ""
                                                        )
                                                        dispatch(
                                                          teamSchedulingAction.loadAgentVacancy(
                                                            {
                                                              // departmentId:
                                                              //   service.departmentId,
                                                              // employeeId:
                                                              //   service.shooterTypeId,
                                                              month: eventMonth,
                                                              year: eventYear,
                                                            }
                                                          )
                                                        )
                                                        setFullscreen(true)
                                                      }}
                                                    ></i>
                                                  </Col>
                                                  {!isEmpty(
                                                    service.shooterTypeId
                                                  ) || editModal ? (
                                                    <Col
                                                      md="12"
                                                      xl="12"
                                                      lg="12"
                                                    >
                                                      <div
                                                        style={{
                                                          color: "#50a5f1",
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        {
                                                          service.shooterPosition
                                                        }
                                                      </div>
                                                    </Col>
                                                  ) : (
                                                    ""
                                                  )}
                                                </>
                                              )}
                                              {service.teamTypeId ===
                                                "Freelancer" ? (
                                                <>
                                                  {" "}
                                                  <Col
                                                    md="4"
                                                    xl="4"
                                                    lg="4"
                                                    className="d-flex flex-row"
                                                  >
                                                    <Input
                                                      type="text"
                                                      name="freelanceAmount"
                                                      value={
                                                        service.freelanceAmount
                                                      }
                                                      className={
                                                        modeMenu ===
                                                          "EventComplete"
                                                          ? "disabled-button"
                                                          : ""
                                                      }
                                                      onChange={(e) =>
                                                        modalChange(
                                                          e,
                                                          index,
                                                          "freelanceAmount",
                                                          serviceId
                                                        )
                                                      }
                                                      placeholder="Enter Amount"
                                                    />
                                                  </Col>
                                                  <Col md="2" xl="2" lg="2">
                                                    <i
                                                      className="fas fa-eye icon-btn disabled-button"
                                                      style={{
                                                        color: "#50a5f1",
                                                        fontSize: "15px",
                                                        marginTop: "10px",
                                                      }}
                                                      onClick={() => {
                                                        setAgentVaccancyModal(
                                                          true
                                                        )
                                                        dispatch(
                                                          teamSchedulingAction.loadAgentOfficeVacancy(
                                                            {
                                                              month: eventMonth,
                                                              year: eventYear,
                                                              // departmentId:
                                                              //   service.departmentId,
                                                              // employeeId:
                                                              //   service.shooterTypeId,
                                                            }
                                                          )
                                                        )
                                                        dispatch(
                                                          teamSchedulingAction.loadAgentVacancy(
                                                            {
                                                              // departmentId:
                                                              //   service.departmentId,
                                                              // employeeId:
                                                              //   service.shooterTypeId,
                                                              month: eventMonth,
                                                              year: eventYear,
                                                            }
                                                          )
                                                        )
                                                        setFullscreen(true)
                                                      }}
                                                    ></i>
                                                  </Col>
                                                </>
                                              ) : (
                                                ""
                                              )}

                                              {service.vendorType !==
                                                "single" &&
                                                !isEmpty(
                                                  service.freelancerTypeId
                                                ) ? (
                                                <div className="mt-2 d-flex flex-row">
                                                  <Col md="7" xl="7" lg="7">
                                                    <Select
                                                      name="subFreelancerTypeId"
                                                      value={
                                                        service.subFreelancerTypeId
                                                          ? {
                                                            value:
                                                              service.subFreelancerTypeId,
                                                            label:
                                                              service.subFreelancerType,
                                                          }
                                                          : ""
                                                      }
                                                      isDisabled={
                                                        modeMenu ===
                                                          "EventComplete"
                                                          ? true
                                                          : false
                                                      }
                                                      placeholder="Select Freelancer"
                                                      onChange={(e) =>
                                                        modalChange(
                                                          e,
                                                          index,
                                                          "subFreelancerTypeId"
                                                        )
                                                      }
                                                      styles={style}
                                                      classNamePrefix="select2-selection"
                                                      options={
                                                        subFreelancerListOptions
                                                      }
                                                    />
                                                  </Col>
                                                  <Col
                                                    md="4"
                                                    xl="4"
                                                    lg="4"
                                                    className="mx-2"
                                                  >
                                                    <Input
                                                      type="text"
                                                      name="subFreelanceAmount"
                                                      value={
                                                        service.subFreelanceAmount
                                                      }
                                                      className={
                                                        modeMenu ===
                                                          "EventComplete"
                                                          ? "disabled-button"
                                                          : ""
                                                      }
                                                      onChange={(e) =>
                                                        modalChange(
                                                          e,
                                                          index,
                                                          "subFreelanceAmount"
                                                        )
                                                      }
                                                      placeholder="Enter Amount"
                                                    />
                                                  </Col>
                                                  {/* <Col
                                                    md="1"
                                                    xl="1"
                                                    lg="1"
                                                    className="mx-2"
                                                  >
                                                    <div
                                                      onClick={() =>
                                                        removeSubFreelancerDetails()
                                                      }
                                                    >
                                                      <i
                                                        style={{ color: "red" }}
                                                        className="fas fa-times"
                                                      ></i>
                                                    </div>
                                                  </Col> */}
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </Row>
                                          </>
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          <div
                                            // href="#"
                                            style={{ color: "#E40D8C" }}
                                            className={
                                              !isEmpty(service.shooterTypeId)
                                                ? ""
                                                : "disabled-button"
                                            }
                                            onClick={() => {
                                              dispatch(
                                                teamSchedulingAction.loadShooterHistory(
                                                  service.shooterTypeId
                                                )
                                              )
                                              setHistoryModal(true)
                                            }}
                                          >
                                            View
                                          </div>
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          <Select
                                            name="paymentStatusId"
                                            value={
                                              service.paymentStatusId
                                                ? {
                                                  value:
                                                    service.paymentStatusId,
                                                  label:
                                                    service.paymentStatus,
                                                }
                                                : ""
                                            }
                                            isDisabled={
                                              true
                                              // modeMenu === "EventComplete"
                                              //   ? true
                                              //   : false
                                            }
                                            placeholder="Mode"
                                            onChange={(e) =>
                                              modalChange(
                                                e,
                                                index,
                                                "paymentStatusId",
                                                serviceId
                                              )
                                            }
                                            // styles={style}
                                            classNamePrefix="select2-selection"
                                            options={paymentStatusOptions}
                                          />
                                        </td>
                                        <td>
                                          <div className="d-flex flex-row">
                                            <div
                                              className={
                                                modeMenu === "EventComplete"
                                                  ? "file btn btn-info disabled-button"
                                                  : "file btn btn-info"
                                              }
                                              style={{
                                                overflow: "hidden",
                                                position: "relative",
                                              }}
                                            >
                                              <i
                                                className="fas fa-paperclip"
                                                style={{ marginRight: "5px" }}
                                              ></i>
                                              {/* Upload */}
                                              <Input
                                                type="file"
                                                name="uploadInput"
                                                // value={service.uploadInput}
                                                accept="application/pdf, audio/mp3 , image/jpeg"
                                                // id="upload-btn"
                                                multiple
                                                onChange={(e) =>
                                                  modalChange(
                                                    e,
                                                    index,
                                                    "uploadInput",
                                                    serviceId
                                                  )
                                                }
                                                style={{
                                                  position: "absolute",
                                                  fontSize: "50px",
                                                  opacity: 0,
                                                  right: 0,
                                                  top: 0,
                                                }}
                                              />
                                            </div>

                                            <div
                                              style={{
                                                marginTop: "-5px",
                                                marginLeft: "-5px",
                                                zIndex: 10,
                                              }}
                                            >
                                              <p
                                                style={{
                                                  fontSize: "12px",
                                                  color: "#ffffff",
                                                  borderRadius: "55%",
                                                  background: "#f1b44c",
                                                  textAlign: "center",
                                                  // padding: "0px 5px",

                                                  width: "17px",
                                                  height: "15px",
                                                  // marginTop: "-46px",
                                                  // marginLeft: "40px",
                                                }}
                                                className="upload-team-input"
                                              >
                                                {!isEmpty(
                                                  service.uploadInput
                                                ) ||
                                                  (editModal &&
                                                    !isEmpty(service.uploadInput))
                                                  ? 1
                                                  : 0}
                                              </p>
                                            </div>
                                          </div>
                                          {/* </Button> */}
                                          {/* </label> */}
                                        </td>
                                        {(removeService &&
                                          service.paymentStatusId === "free") ||
                                          (editModal &&
                                            service.paymentStatusId ===
                                            "free") ? (
                                          <td style={{ textAlign: "center" }}>
                                            <i
                                              className="fa fa-times remove-icon"
                                              onClick={() =>
                                                removeServiceDetails(index)
                                              }
                                            ></i>
                                          </td>
                                        ) : (
                                          ""
                                        )}
                                      </tr>
                                    )
                                  })
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={8}
                                      className="text-align-center"
                                    >
                                      No Records Found..
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <div style={{ float: "right" }}>
                          {eventServiceModal && open === false ? (
                            <>
                              <Button
                                className={
                                  modeMenu === "EventComplete"
                                    ? "disabled-button btn btn-success mb-2"
                                    : "btn btn-success mb-2"
                                }
                                onClick={() => updateTeamEvents(idx)}
                              >
                                Update
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                type="submit"
                                className={
                                  modeMenu === "EventComplete"
                                    ? "disabled-button btn btn-success mb-2"
                                    : "btn btn-success mb-2"
                                }
                                onClick={(e) => addTeamEvents(e,idx)}
                              >
                                Submit
                              </Button>
                            </>
                          )}
                        </div>
                      </Col>
                    </div>
                  </Collapse>
                </Row>
              )
            })
          ) : (
            <Row className="question-card-content" key={0}>
              <Col>
                <p
                  style={{
                    fontSize: "15px",
                    marginBottom: "-12px",
                    fontWeight: 550,
                    marginTop: "-1px",
                  }}
                >
                  {"No Events"}
                </p>
              </Col>
              <Col>
                <div
                  style={{
                    color: "#291213",
                    height: "22px",
                    width: "max-content",
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: "24px",
                    float: "right",
                    display: "flex",
                  }}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  onClick={() => {
                    setOpen(!open)
                  }}
                >
                  <i className="fas fa-angle-down"></i>
                </div>
              </Col>
            </Row>
          )}
        </div>
        {finalCommitModal && (
          <Modal
            show={finalCommitModal}
            onHide={handleFinalCommitModal}
            size="md"
          // fullscreen={fullscreen}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Confirm
            </Modal.Header>
            <Modal.Body>Do you want to commit the Event ?</Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => setFinalCommitModal(false)}
              >
                Close
              </Button>
              <Button
                type="button"
                className="btn btn-success"
                onClick={() => finalCommit()}
              >
                Commit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {eventCommit && (
          <Modal
            show={eventCommit}
            onHide={handleEventCommitModal}
            size="md"
          // fullscreen={fullscreen}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Confirm
            </Modal.Header>
            <Modal.Body>Do you want to commit the Event ?</Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => setEventCommit(false)}
              >
                Close
              </Button>
              <Button
                className="btn btn-success"
                onClick={() => eventFinalCommit()}
              >
                Commit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {agentVaccancyModal && (
          <Modal
            show={agentVaccancyModal}
            onHide={handleModal}
            fullscreen={fullscreen}
          >
            {/* <Modal.Header
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col md="12" lg="12" sm="12">
                
              </Col>
            </Modal.Header> */}
            <Modal.Body>
              <Row className="mt-2 mb-3">
                <Col md="12" lg="12" xl="12" sm="12" xs="12">
                  <div style={{ textAlign: "center" }}>
                    <h1>
                      {!isEmpty(agentVacantMonth)
                        ? agentVacantMonthName
                        : currentMonth}{" "}
                      - {!isEmpty(agentVacantYear) ? agentVacantYear : year}
                    </h1>
                  </div>
                  <div style={{ float: "right", marginTop: "-33px" }}>
                    <span>
                      <i
                        className="fa fa-times quote-close font-size-14"
                        aria-hidden="true"
                        onClick={() => setAgentVaccancyModal(false)}
                      ></i>
                    </span>
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md="3" lg="3" sm="3">
                  <ReactSearchAutocomplete
                    name="salesAgent"
                    items={employeeOptions}
                    value={salesAgent}
                    type="autoComplete"
                    resultStringKeyName="label"
                    showIcon={false}
                    onSelect={(e) => setSalesAgent(e)}
                    onChange={(e) => setSalesAgent(e.target.value)}
                    placeholder="Search Employee"
                    fuseOptions={fuseOptions} // Search on both fields
                    styling={{
                      height: "34px",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      width: "140px",
                      backgroundColor: "white",
                      boxShadow: "none",
                      hoverBackgroundColor: "#E40D8C",
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "Courier",
                      iconColor: "green",
                      clearIconMargin: "3px 8px 0 0",
                      zIndex: 10,
                    }}
                  />
                </Col>
                <Col md="3" lg="3" sm="3">
                  <Input
                    type="date"
                    name="agentEventDate"
                    value={agentEventDate}
                    onChange={(e) => setAgentEventDate(e.target.value)}
                    placeholder="Select Date"
                  />
                </Col>
                <Col md="2" lg="2" sm="2">
                  <Button
                    className="btn btn-success"
                    onClick={() => agentVacancySearch()}
                  >
                    {/* <i
                        className="fa fa-search"
                        // style={{
                        //   // marginLeft: "-25px",
                        //   marginTop: "10px",
                        //   color: "blue",
                        // }}
                      ></i> */}
                    Search
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col sm="12" md="12" lg="12">
                  <Table>
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        overflowY: "auto",
                        background: "#ffffff",
                      }}
                    >
                      <tr>
                        <th className="header-fixed">Branch</th>
                        {/* <th> */}
                        {!isEmpty(agent_vacancy_details) &&
                          agent_vacancy_details.length > 0
                          ? Object.entries(agent_vacancy_details).map(
                            ([key, value]) => {
                              return (
                                <th
                                  key={key}
                                  style={{
                                    color:
                                      value.employeeId === selectedAgentData
                                        ? "#ffffff"
                                        : "#47d56c",
                                    background:
                                      value.employeeId === selectedAgentData
                                        ? "#af2476"
                                        : "#ffffff",
                                    fontWeight: 450,
                                    fontSize: "13px",
                                  }}
                                  className={"header-fixed"}
                                >
                                  {value.branchName}
                                </th>
                              )
                            }
                          )
                          : []}
                        {/* </th> */}
                      </tr>
                      <tr>
                        <th className="header-fixed">Employee</th>
                        {!isEmpty(agent_vacancy_details) &&
                          agent_vacancy_details.length > 0
                          ? Object.entries(agent_vacancy_details).map(
                            ([key, value]) => {
                              return (
                                <th
                                  key={key}
                                  style={{
                                    color:
                                      value.employeeId === selectedAgentData
                                        ? "#ffffff"
                                        : "#47d56c",
                                    fontWeight: 450,
                                    fontSize: "13px",
                                    background:
                                      value.employeeId === selectedAgentData
                                        ? "#af2476"
                                        : "#ffffff",
                                  }}
                                  className={"header-fixed"}
                                >
                                  {value.employeeName}
                                </th>
                              )
                            }
                          )
                          : []}
                      </tr>
                      <tr>
                        <th className="header-fixed">Emp Code</th>
                        {!isEmpty(agent_vacancy_details) &&
                          agent_vacancy_details.length > 0
                          ? Object.entries(agent_vacancy_details).map(
                            ([key, value]) => {
                              return (
                                <th
                                  key={key}
                                  style={{
                                    color:
                                      value.employeeId === selectedAgentData
                                        ? "#ffffff"
                                        : "#47d56c",
                                    fontWeight: 450,
                                    fontSize: "13px",
                                    background:
                                      value.employeeId === selectedAgentData
                                        ? "#af2476"
                                        : "#ffffff",
                                  }}
                                  className={"header-fixed"}
                                >
                                  {value.employeeCode}
                                </th>
                              )
                            }
                          )
                          : []}
                      </tr>
                      <tr>
                        <th className="header-fixed">Designation</th>
                        {!isEmpty(agent_vacancy_details) &&
                          agent_vacancy_details.length > 0
                          ? Object.entries(agent_vacancy_details).map(
                            ([key, value]) => {
                              console.log(value.employeeId, "employeeId")
                              return (
                                <th
                                  key={key}
                                  style={{
                                    color:
                                      value.employeeId === selectedAgentData
                                        ? "#ffffff"
                                        : "#47d56c",
                                    fontWeight: 450,
                                    fontSize: "13px",
                                    background:
                                      value.employeeId === selectedAgentData
                                        ? "#af2476"
                                        : "#ffffff",
                                  }}
                                  className={"header-fixed"}
                                >
                                  {value.designationName}
                                </th>
                              )
                            }
                          )
                          : []}
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(agent_office_details) &&
                        agent_office_details &&
                        agent_office_details.length > 0
                        ? agent_office_details.map((data, index) => {
                          const agentVacancyDate = !isEmpty(data)
                            ? moment(data.date).format("DD-MM-YYYY")
                            : ""
                          console.log(
                            agentVacancyDate,
                            "equipmentVacancyDate"
                          ) // console.log(data, "data fron vacancy")
                          return (
                            <tr
                              key={index}
                              style={{
                                color: "#4fccd9",
                                fontWeight: 450,
                                fontSize: "13px",
                                width: "80px",
                              }}
                            >
                              {/* <td style={{position: "sticky",background: "#ffffff", left: 0,overflowX: 'auto',}}> {data.date}</td> */}
                              <td
                                style={{
                                  color:
                                    eventDate === agentVacancyDate
                                      ? "#ffffff"
                                      : "#47d56c",
                                  fontWeight: 450,
                                  fontSize: "13px",
                                  background:
                                    eventDate === agentVacancyDate
                                      ? "#af2476"
                                      : "#ffffff",
                                }}
                              >
                                {" "}
                                {data.date}
                              </td>
                              {/* <td colSpan={30}> */}
                              {data.detail.map((office, index) => {
                                return (
                                  <td
                                    style={{
                                      color:
                                        office.isOffice === true &&
                                          eventDate === agentVacancyDate
                                          ? "#ffffff"
                                          : office.isOffice === false &&
                                            eventDate !== agentVacancyDate
                                            ? "#0034f9"
                                            : office.isLeave === true &&
                                              eventDate === agentVacancyDate
                                              ? "#ffffff"
                                              : office.isLeave === false &&
                                                eventDate !== agentVacancyDate
                                                ? "#e40d8c"
                                                : !isEmpty(office.schedule)
                                                  ? "#b0b7f3"
                                                  : "#E40D8C",
                                      fontWeight: 450,
                                      fontSize: "13px",
                                      background:
                                        eventDate === agentVacancyDate
                                          ? "#af2476"
                                          : "#ffffff",
                                    }}
                                    key={index}
                                    onClick={() => officeEditDetails(office)}
                                  >
                                    {office.isOffice === true
                                      ? "OFFICE"
                                      : office.isLeave === true
                                        ? "LEAVE"
                                        : office.schedule}
                                    {/* {data.employee_id} */}
                                  </td>
                                )
                              })}
                              {/* </td> */}
                            </tr>
                          )
                        })
                        : []}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => setAgentVaccancyModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {historyModal && (
          <Modal
            show={historyModal}
            onHide={handleHistoryModal}
            size="lg"
          // fullscreen={fullscreen}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Service History
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col sm="12" md="12" lg="12">
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Lead No</th>
                        <th>Event Date</th>
                        <th>Event Name</th>
                        <th>Event No</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Venue Location</th>
                        <th>Venue Name</th>
                        <th>Service Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(shooter_history) &&
                        shooter_history.length > 0 ? (
                        shooter_history.map((history, index) => {
                          return (
                            <tr key={history._id}>
                              <th>{index + 1}</th>
                              <td>{history.leadNo}</td>
                              <td>
                                {moment(history.eventDate).format("DD-MM-YYYY")}
                              </td>
                              <td>{history.eventName}</td>
                              <td>{history.eventNo}</td>
                              <td>{history.startTime}</td>
                              <td>{history.endTime}</td>
                              <td>{history.eventLocation}</td>
                              <td>{history.venueName}</td>
                              <td>{history.serviceName}</td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr key={0}>
                          <td colSpan={10} style={{ textAlign: "center" }}>
                            No records found..
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => setHistoryModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {commitHistoryModal && (
          <Modal
            show={commitHistoryModal}
            onHide={handleCommitHistoryModal}
            size="lg"
          // fullscreen={fullscreen}
          >
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Commit History
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col sm="12" md="12" lg="12">
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Committed Date</th>
                        <th>Committed By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(commitHistoryDetails) &&
                        commitHistoryDetails &&
                        commitHistoryDetails.length > 0 ? (
                        commitHistoryDetails.map((history, index) => {
                          return (
                            <tr key={history._id}>
                              <th>{index + 1}</th>
                              <td>
                                {moment(history.iscommitedOn).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td>{history.isCommitedBy.name}</td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr key={0}>
                          <td colSpan={10} style={{ textAlign: "center" }}>
                            No records found..
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-danger"
                onClick={() => setCommitHistoryModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Container>
    </React.Fragment>
  )
}

TeamSchedulingDetails.propTypes = {
  dispatch: PropTypes.func,
  clientProfile: PropTypes.any,
  modeMenu: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TeamSchedulingDetails)
)